<template>
  <div data-v-9774ec9a="" class="index-container">
    <div data-v-9774ec9a="" class="warpper">
      <div data-v-9774ec9a="" class="my-swipe van-swipe">
        <div class="van-swipe__track">
          <div v-if="type==1" data-v-9774ec9a="" class="van-swipe-item">
            <div data-v-9774ec9a="" id="InvitationLink">
              <div class="toptitle">
                <img @click="back()" src="/static/image/new/arrow-left.png">
                {{ $t('邀请链接') }}
              </div>
              <div class="link-container">
                <div class="title-img-box">
                  <img src="/static/image/new/inviter/inviter-title-img1.png" alt="" class="link-title-img1">
                  <img src="/static/image/new/inviter/inviter-title-img2.png" alt="" class="link-title-img2">
                </div>
                <div class="step-box">
                  <div class="step-item">
                    <img src="/static/image/new/inviter/share-icon1.png" class="icon" alt="">
                    <div class="title">
                      <div>分享链接</div>
                      <div>给你好友</div>
                    </div>
                  </div>
                  <div class="arrow-box">
                    <img src="/static/image/new/mine/arrow-yellow.png" alt="">
                  </div>
                  <div class="step-item">
                    <img src="/static/image/new/inviter/share-icon2.png" class="icon" alt="">
                    <div class="title">
                      <div>好友接受</div>
                      <div>您的邀请</div>
                    </div>
                  </div>
                  <div class="arrow-box">
                    <img src="/static/image/new/mine/arrow-yellow.png" alt="">
                  </div>
                  <div class="step-item">
                    <img src="/static/image/new/inviter/share-icon3.png" class="icon" alt="">
                    <div class="title">
                      <div>好友进行</div>
                      <div>存款投注</div>
                    </div>
                  </div>

                </div>
                <div class="submit-btn" @click="show=true">{{ $t('立即邀请') }}</div>
              </div>
            </div>
          </div>
          <div v-else-if="type==2" data-v-9774ec9a="" class="van-swipe-item">
            <div data-v-9774ec9a="" id="DetailRecord">
              <div class="toptitle">
                <img @click="back()" src="/static/image/new/arrow-left.png">
                {{$t('礼金介绍') }}
              </div>
              <div class="record">
                <div class="detail_ban">
                  <div class="detail_img"><img
                    src="https://tupian.fenghuang8866.com/ng/yaoqingfengmian4.jpg" alt="#"
                    class="record_two"></div>
                </div>
                <div class="detail_ban">
                  <div class="detail_img"><img
                    src="https://tupian.fenghuang8866.com/ng/yaoqingfengmian2.png" alt="#"
                    class="record_two"></div>
                </div>
                <div class="detail_ban">
                  <div class="detail_img"><img src="https://tupian.fenghuang8866.com/ng/fengmian2.png"
                                               alt="#" class="record_two"></div>
                </div>
                <div class="detail_ban">
                  <div class="detail_img"><img src="https://tupian.fenghuang8866.com/ng/fengmian3.png"
                                               alt="#" class="record_two"></div>
                </div>
                <div class="detail_ban">
                  <div class="detail_img"><img
                    src="https://tupian.fenghuang8866.com/ng/yqewjlfengmian.jpg" alt="#"
                    class="record_two"></div>
                </div>
                <div style="height: 200px; width: 100%;"></div>
              </div>
            </div>
          </div>
          <div data-v-9774ec9a="" v-else-if="type==3" class="van-swipe-item">
            <div data-v-9774ec9a="" id="defitscont">
              <div class="toptitle">
                <img @click="back()" src="/static/image/new/arrow-left.png">
                {{
                  $t('明细记录')
                }}
              </div>
              <div class="contentbox">
                <div class="contentboxinner">
                  <div class="collebox" :class="{colleboxac:!show2}">
                    <div class="lvtitle" @click="show2=!show2,show3=false">
                      <div>
                       {{ $t('下级概览') }}
                      </div>
                      <img src="/static/image/new/inviter/more-arrow.png" class="ngblue">
                    </div>
                    <div class="showdetbox withSoild">
                      <div class="showdetdiv">
                        <div>{{ $t('下级成员统计') }}</div>
                        <div>0</div>
                      </div>
                      <div class="showdetdiv">
                        <div>{{ $t('本月新增') }}</div>
                        <div>0</div>
                      </div>
                      <div class="showdetdiv">
                        <div>{{ $t('本月活跃成员') }}</div>
                        <div>0</div>
                      </div>
                      <div class="showdetdiv">
                        <div>{{ $t('本月有效活跃') }}</div>
                        <div>0</div>
                      </div>
                      <div class="showdetdiv">
                        <div>{{ $t('今日新增') }}</div>
                        <div>0</div>
                      </div>
                      <div class="showdetdiv">
                        <div>{{ $t('今日活跃') }}</div>
                        <div>0</div>
                      </div>
                      <div class="showdetdiv">
                        <div> {{ $t('本月新增有效会员') }} <span class="van-popover__wrapper"
                                                                 actions-direction="horizontal"><i
                          class="van-icon van-icon-info"
                          style="margin-bottom: -3px;"><!----></i></span></div>
                        <div>0</div>
                      </div>
                      <div class="showdetdiv">
                        <div>{{ $t('本月存款') }}({{ $t('元') }})</div>
                        <div>0.00</div>
                      </div>
                      <div class="showdetdiv">
                        <div>{{ $t('今日存款') }}({{ $t('元') }})</div>
                        <div>0.00</div>
                      </div>
                    </div>
                  </div>
                  <div class="collebox" style="margin-top: 10px;" :class="{colleboxac:!show3}">
                    <div class="lvtitle" @click="show3=!show3,show2=false">
                      <div> {{ $t('数据列表') }}
                      </div>
                      <img src="/static/image/new/inviter/more-arrow.png" class="ngblue">
                    </div>
                    <div class="listTag">
                      <div class="tab-list">
                        <div class="tab-item active">{{ $t('礼金记录') }}</div>
                        <div class="tab-item">{{ $t('好友明细') }}</div>
                      </div>
                      <div class="yxdivbox yxdivTime">
                        <div class="selediv tiemselediv">2024-07-26<img
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAMAAABV0m3JAAAATlBMVEUAAABrcY1gc4Zqco1rco1rco1rcYxqco1qco1rcY1qcI1qc4xrco1rb4tmbYNrco1rco1qco1rco1sco1pc4xsb4xscY5nbYxoaItrco1zwfScAAAAGXRSTlMA8wrs5vXi0ce8PzUiGxHc16ifdG1HLSoWMtagrQAAAFdJREFUCNdlz0cWgCAAA9GAKB174f4XlYeolL+cVYK19xWygfhGh7mNC6ism6QAFWUTFIHjeeMOkR3/Nl1IDHvbYPE5u6cxg4wmceCBggrHiEZlZ4NCcgOqzA2/OZg9RgAAAABJRU5ErkJggg==">
                        </div>
                        <font>至</font>
                        <div class="selediv tiemselediv">2024-07-26<img
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAMAAABV0m3JAAAATlBMVEUAAABrcY1gc4Zqco1rco1rco1rcYxqco1qco1rcY1qcI1qc4xrco1rb4tmbYNrco1rco1qco1rco1sco1pc4xsb4xscY5nbYxoaItrco1zwfScAAAAGXRSTlMA8wrs5vXi0ce8PzUiGxHc16ifdG1HLSoWMtagrQAAAFdJREFUCNdlz0cWgCAAA9GAKB174f4XlYeolL+cVYK19xWygfhGh7mNC6ism6QAFWUTFIHjeeMOkR3/Nl1IDHvbYPE5u6cxg4wmceCBggrHiEZlZ4NCcgOqzA2/OZg9RgAAAABJRU5ErkJggg==">
                        </div>
                      </div>
                      <div class="yxdivboxasd yxdivGift">
                        <div>{{ $t('重置') }}</div>
                        <div>{{ $t('查询') }}</div>
                      </div>
                      <div class="tablebox">
                        <div class="tableboxinner">
                          <div id="#rtfixedbox" class="rtfixedbox">
                            <div class="rtfixedboxinner cashGift">
                              <div class="lineboxdiv">
                                <div>{{ $t('日期') }}</div>
                                <div>{{ $t('礼金') }}</div>
                                <div>{{ $t('备注') }}</div>
                              </div>
                            </div>
                          </div><!---->
                        </div>
                        <div class="nonedat"><img
                          src="data:image/png;base64,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"
                          class="nonedatImg"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div><!----><!---->
            </div>
          </div>
        </div>
      </div>
      <div data-v-9774ec9a="" class="bottom-taps">
        <div @click="type=1" data-v-9774ec9a="" class="bottom-taps-list">
          <img data-v-9774ec9a="" v-if="type==1" src="/static/image/new/inviter/inviter-tab1-active.png" alt="#">
          <img v-else data-v-9774ec9a="" src="/static/image/new/inviter/inviter-tab1.png" alt="">
          <p data-v-9774ec9a="" :class="{tapsactive:type==1}">{{ $t('邀请链接') }}</p>
        </div>
        <div @click="type=2" data-v-9774ec9a="" class="bottom-taps-list">
          <img data-v-9774ec9a="" v-if="type==2" src="/static/image/new/inviter/inviter-tab2-active.png" alt="#">
          <img data-v-9774ec9a="" v-else src="/static/image/new/inviter/inviter-tab2.png" alt="">
          <p data-v-9774ec9a="" :class="{tapsactive:type==2}">{{ $t('礼金介绍') }}</p>
        </div>
        <div @click="type=3" data-v-9774ec9a="" class="bottom-taps-list">
          <img data-v-9774ec9a="" v-if="type==3" src="/static/image/new/inviter/inviter-tab3-active.png" alt="#">
          <img data-v-9774ec9a="" v-else src="/static/image/new/inviter/inviter-tab3.png" alt="">
          <p data-v-9774ec9a="" :class="{tapsactive:type==3}">{{ $t('明细记录') }}</p>
        </div>
      </div>
    </div>
    <div data-v-9774ec9a="" id="qrcode-bgImg" class="qrcode-container" v-show="show">
        <div class="qrcode-title">邀请有好礼 红包等你</div>
        <div class="time">活动时间: 长期有效</div>
        <div class="tag-list">
          <div class="tag">彩票</div>
          <div class="tag">捕鱼</div>
          <div class="tag">棋牌</div>
          <div class="tag">电子</div>
          <div class="tag">真人</div>
          <div class="tag">电竞</div>
          <div class="tag">体育</div>
        </div>
      <img src="/static/image/new/inviter/qrcode-img.png" class="qrcode-img" alt="">
    </div>
    <div class="qrcode-popup"></div>
    <div class="van-overlay" style="z-index: 2020;" v-show="show" @click="show = false"></div>
<!--    <div data-v-9774ec9a=""-->
<!--         class="van-popup van-popup&#45;&#45;round van-popup&#45;&#45;bottom van-popup&#45;&#45;safe-area-inset-bottom van-share-sheet"-->
<!--         style="width: 375px; z-index: 2021;" v-show="show">-->
<!--      <div class="van-share-sheet__options">-->
<!--        <div @click="copy" role="button" tabindex="0" class="van-share-sheet__option"><img-->
<!--          src="data:image/png;base64,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"-->
<!--          class="van-share-sheet__icon"><span class="van-share-sheet__name">{{ $t('保存链接') }}</span></div>-->
<!--        <div role="button" tabindex="0" class="van-share-sheet__option"><img-->
<!--          src="data:image/png;base64,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"-->
<!--          class="van-share-sheet__icon"><span class="van-share-sheet__name">{{ $t('保存图片') }}</span></div>-->
<!--        <div role="button" tabindex="0" class="van-share-sheet__option"><img-->
<!--          src="data:image/png;base64,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"-->
<!--          class="van-share-sheet__icon"><span class="van-share-sheet__name">{{ $t('保存二维码') }}</span></div>-->
<!--      </div>-->
<!--      <button @click="show=false" type="button" class="van-share-sheet__cancel">{{ $t('取消') }}</button>-->
<!--    </div>-->
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      type: 1,
      show: false,
      show2: true,
      show3: false
    };
  },
  created() {

  },
  methods: {
    async copy() {
      var link = 'http://cs.vip3329.cc/#/reg'
      try {
        await navigator.clipboard.writeText(link);
        alert(this.$t('链接已复制到剪贴板'));
      } catch (err) {
        alert(this.$t('复制链接失败'));
      }
    },
    back() {
      window.history.go(-1)
    }
  },
};
</script>

<style scoped lang="scss">

.index-container {
  width: 100%;
  height: 100vh;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC, PingFang SC;
}

.textcenter, .tiemselepop .btndivs .btndiv, .tiemselepop .timetitle {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center
}

.textcenter, .textleft, .tiemselepop .btndivs .btndiv, .tiemselepop .linedivboxdd div, .tiemselepop .smtips, .tiemselepop .timetitle, .tiemselepop .timetitle span {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.textleft, .tiemselepop .linedivboxdd div, .tiemselepop .smtips, .tiemselepop .timetitle span {
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start
}

.textright, .tiemselepop .linedivboxdd div:nth-child(2) {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.tiemselepop {
  background: #f5f6fa
}

.tiemselepop .timetitle {
  float: left;
  width: 100%;
  height: 1.17333rem;
  position: relative;
  font-size: .48rem;
  font-family: PingFang SC;
  font-weight: 700;
  color: #373c4a;
  background: #fff
}

.tiemselepop .timetitle img {
  width: .32rem;
  height: .53333rem;
  position: absolute;
  left: .50667rem
}

.tiemselepop .timetitle span {
  width: 2.08rem;
  height: 1.17333rem;
  position: absolute;
  right: 0;
  font-size: .42667rem;
  color: #373c4a;
  font-weight: 500
}

.tiemselepop .smtips {
  height: .8rem;
  font-size: .29333rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #828fbe;
  padding-left: .4rem
}

.tiemselepop .btndivs, .tiemselepop .smtips {
  float: left;
  width: 100%;
  padding-top: .4rem;
  background: #fff
}

.tiemselepop .btndivs {
  padding-left: .13333rem
}

.tiemselepop .btndivs .btndiv {
  float: left;
  width: 2.08rem;
  height: .93333rem;
  background: #fff;
  border: .02667rem solid #d9ddeb;
  border-radius: .13333rem;
  font-size: .37333rem;
  font-weight: 500;
  color: #373c4a;
  margin-left: .26667rem;
  margin-bottom: .26667rem
}

.tiemselepop .btndivs .btndivac {
  background: -webkit-linear-gradient(left, #2c66ee, #85ccf5);
  background: linear-gradient(90deg, #2c66ee, #85ccf5);
  color: #fff;
  border: 0 solid transparent
}

.tiemselepop .linedivboxdd {
  float: left;
  width: 100%;
  height: 1.33333rem;
  background: #fff;
  padding: 0 .4rem
}

.tiemselepop .linedivboxdd div {
  float: left;
  width: 30%;
  height: 1.33333rem;
  font-size: .42667rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #373c4a
}

.tiemselepop .linedivboxdd div:nth-child(2) {
  width: 70%
}

.tiemselepop .linedivboxdd div:nth-child(2) img {
  width: .16rem;
  height: .26667rem;
  margin-left: .34667rem
}

.tiemselepop .spdivline {
  border-bottom: .02667rem solid #c6c6ca;
  margin-bottom: 0
}
#InvitationLink .link-container {
  background-image: url("/static/image/new/inviter/cover-img.png");
  background-size: 100% 100%;
  width: 100%;
  height: 14.5rem;
  position: relative;
  padding: .56rem .67rem;
  box-sizing: border-box;
  .title-img-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .link-title-img1 {
    width: 3.47rem;
    margin-bottom: .16rem;
  }
  .link-title-img2 {
    width: 5.97rem;
  }
  .step-box {
    display: flex;
    justify-content: space-between;
    background: rgba(0, 0, 0, 0.30);
    border: .03rem solid rgba(255, 255, 255, 0.10);
    padding: .53rem .83rem;
    margin-top: 6.7rem;
    .step-item {
      .icon {
        width: 1.01rem;
        height: 1.01rem;
      }
      .title {
        div {
          font-size: 0.27rem;
          line-height: 0.37rem;
          text-align: center;
        }
      }
    }
    .arrow-box {
      padding-top: .21rem;
      img {
        width: 0.59rem;
      }
    }
  }
  .submit-btn {
    height: 1.23rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
    border-radius: .6rem;
    font-size: 0.43rem;
    font-weight: bold;
    margin-top: .27rem;
  }
}

#InvitationLink .inviteBanne {
  width: 5.46667rem;
  height: 1.06667rem;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZoAAABQCAMAAAAX3EM3AAAAtFBMVEUAAAA9jPA9jfCH3v9OoP+G3v+A1f89i/CG3/8+jO+G3v+G3v+G3v+G3v+G3v8+jO8caOcfbOgib+kkcuk6ie4reuspd+ondOqC2v48i+82he00gu0xgOx+1v170/150Pw4h+4wfuwufOs/ke+A2P52zfxzyvtwxvprwflovfhluvhgtPdQovNGl/FDlPBuw/pjt/dcsPZarfVXq/VVqPRSpfNImvFyyPtdsvZNoPJMnvJKnfJqYyi/AAAADnRSTlMA31dWBOEGq6qMidvZk78VRvIAAAK3SURBVHja7NfZToNAGIbhoWAXTRgXxLKoQN03drrd/3350YkemDRhGgpM/J9D1oMvbwhsZ6xPT8z+zHce4LZ2V7uvPcITLJfPEMfxC7zCGyRJ8g6rVZqmWZbleV4URVmWH7BebzbbbVVVn/AFC+CcO45lWUHggud5vu+HYRhF0TXYtRu4ql0KFz/O9xLncS3uwt22jWdFURji4XiF6wZBYIEDvIGFNhkZ7Jd+ZvZnTsv8pY2YYJyaUv5lM3vGwfH2l4GZCEduGWrmyM0IMwa6KYWaOXYzwoixsdT3n5rppBnQDMloqJlOmhHZTM3mqJmumoEJo/+ZQTbDucbMxqiZDpsBiWmomQObUWwaamaw06ixTBvNKDYNNTPYadRYpo1mFJuGmhnsNGos00Yzik1DzQx2GjWW6b2ZBtNQM4c2o9o0aizzzT4dnAAAwkAQ7L9r/5oo5OMebA3DAM48aTwzPZNGkyGDOPOg8cz0TBpNhgzkzJXGM9MzaTQZMpgzFxrPTM+k0WTIgM60NJ6ZnkmjyZBBnWloPPP/TEPjmf9nShrPEM6UNJ4hnCloPMM4U9B4hnHmoPEM5cxB4xnKmY3GM5wzG41nVnv3csMgEARBdDDIP9ma/LOlQasVZFCH6hRK79wcM7c0miGZuaXRDMnMJY1mWGYuaTTDMjPTaIZmZqbRDM3MSKMZnpmRRjM8M2cazRDNJI1mmGaSRjNMM0mjGaaZpNEM00zSaIZpJmk0wzSTNJphmkkazTDNJI1mmGaSRjNMM0mjGaaZpNEM00zSaIZpJmk0wzSTNJphmkkazUDLdGkGWqZLM9AyXZqBlunSDLRMl2agZbp+mmGWWeqtGWSZftWqGWSZfuTGTjPEMsuzatUMsEzQZF/N8Mp86tj21wyuzDbvuTVDKjPuueepvWYYZeap/Q6nX81wpsyQSAAAAABJRU5ErkJggg==);
  text-align: center;
  line-height: 1.06667rem;
  background-size: 100%;
  margin: .10667rem auto;
  font-size: .42667rem;
  color: #fff
}

#InvitationLink .inviteCode {
  height: 9.33333rem;
  width: 87.5%;
  position: absolute;
  top: 3.78667rem;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  z-index: 6666
}

.textcenter, .tiemselepop .toptitle, .tiemselepop .toptitle div {
  display: flex;
  justify-content: center;
  align-items: center
}

.tiemselepop {
  height: 100%;
  padding-bottom: 1.33333rem;
  box-sizing: border-box
}

.tiemselepop, .tiemselepop .toptitle {
  float: left;
  width: 100%;
}

.tiemselepop .toptitle {
  width: 0.43rem;
  font-size: .48rem;
  position: relative
}

.tiemselepop .toptitle img {
  float: left;
  width: .26667rem;
  height: .48rem;
  position: absolute;
  left: .48rem
}

.tiemselepop .toptitle div {
  font-weight: 400;
  font-size: .37333rem;
  float: right;
  width: 2.4rem;
  height: 1.30667rem;
  position: absolute;
  top: 0;
  right: 0
}

.tiemselepop .detail {
  width: 100%
}

#DetailRecord {
  height: 100%;
}

#DetailRecord .toptitle {
  width: 100%;
  height: 1.17rem;
  font-size: .48rem;
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

#DetailRecord .toptitle img {
  width: 0.43rem;
  position: absolute;
  left: .4rem
}

#DetailRecord .record {
  width: 87.5%;
  margin: .42667rem auto;
  height: 100%;
  overflow: scroll;
  margin-bottom: 4rem
}

#DetailRecord .record .giveNotice {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  margin-bottom: .32rem
}

#DetailRecord .record .giveNotice img {
  width: .42667rem;
  height: .42667rem;
  font-size: .32rem;
  color: #0b1028
}

#DetailRecord .record .giveNotice .van-notice-bar {
  background-color: #f5f6fd !important;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  color: #0b1028;
  padding: 0;
  height: .37333rem
}

#DetailRecord .record .detail_ban {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column
}

#DetailRecord .record .detail_ban .detail_img {
  height: 4rem;
  width: 100%;
  margin-bottom: .26667rem;
  border-radius: .8rem
}

#DetailRecord .record .detail_ban .detail_img .record_two {
  height: 4rem;
  width: 100%;
  border-radius: .4rem
}

#xiajixq .contentbox .contentboxinner .detailinfo .rtdivdt {
  height: 1.33333rem;
  border-radius: 50%
}

#xiajixq .contentbox .contentboxinner .detailinfo .rtdivdt img {
  border-radius: 50%
}

.van-tabs__line {
  width: 1.6rem
}


#defitscont .collebox .lvtitle, #defitscont .contentbox .contentboxinner .yxdivbox, #defitscont .contentbox .contentboxinner .yxdivbox .selediv, .textleft {
  display: flex;
  justify-content: flex-start;
  align-items: center
}

#defitscont .contentbox .contentboxinner .yxdivboxasd, #defitscont .contentbox .contentboxinner .yxdivbox span, .textright {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

#defitscont .contentbox .contentboxinner .cashGift, #defitscont .contentbox .contentboxinner .friendList, #defitscont .contentbox .contentboxinner .rtfixedboxinner {
  width: 10rem !important
}


#defitscont .contentbox .contentboxinner .yxdivbox span {
  float: left;
  width: 1.73333rem;
  height: .93333rem;
  box-sizing: border-box;
  padding-right: .16rem
}

#defitscont .contentbox .contentboxinner .yxdivbox .selediv {
  float: left;
  width: 3.81rem;
  height: .91rem;
  background: rgba(255, 255, 255, 0.10);
  padding-left: .4rem;
  position: relative;
  color: #bbb;
  font-size: .32rem;
  outline: none;
  border-radius: .16rem;
}

#defitscont .contentbox .contentboxinner .yxdivbox .selediv img {
  width: .26667rem;
  height: .16rem;
  position: absolute;
  right: .4rem
}

#defitscont .contentbox .contentboxinner .yxdivbox font {
  margin: 0 .24rem;
  font-weight: 500;
}

#defitscont .contentbox .contentboxinner .yxdivbox .tiemselediv {
  float: none
}

#defitscont .contentbox .contentboxinner .yxdivTime {
  display: flex;
  justify-content: space-between;
}

#defitscont .contentbox .contentboxinner .yxdivboxasd {
  margin-top: .43rem;
  margin-bottom: .45rem;
  display: flex;
  justify-content: space-between;
}

#defitscont .contentbox .contentboxinner .yxdivboxasd div {
  width: 4.21rem;
  height: 1.07rem;
  background: rgba(255, 255, 255, 0.10);
  border: .03rem solid rgba(255, 255, 255, 0.10);
  border-radius: .16rem;
  color: #bbb;
  font-size: .43rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

#defitscont .contentbox .contentboxinner .yxdivboxasd div:nth-child(2) {
  background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
  color: #fff;
  border-color: #4B5BF1;
}

#defitscont .contentbox .contentboxinner .yxdivGift div:first-child {
  border: none;
  background-color: #f5f6fa
}

#defitscont .contentbox .contentboxinner .tablebox {
  overflow-x: scroll;
  width: 100%;
}

#defitscont .contentbox .contentboxinner .tablebox .tableboxinner {
  float: left;
  position: relative
}

#defitscont .contentbox .contentboxinner .tablebox .tableboxinner .ltfixedbox {
  float: left;
  width: 1.86667rem;
  position: absolute
}

#defitscont .contentbox .contentboxinner .tablebox .tableboxinner .ltfixedbox .lineboxdiv {
  width: 1.97333rem
}

#defitscont .contentbox .contentboxinner .tablebox .tableboxinner .ltfixedbox .lineboxdiv div {
  width: 1.86667rem
}

#defitscont .contentbox .contentboxinner .tablebox .tableboxinner #rtfixedbox {
  float: left;
  width: 100%;
  overflow-x: auto
}

#defitscont .contentbox .contentboxinner .tablebox .tableboxinner #rtfixedbox .rtfixedboxinner {
  width: 10rem !important
}

#defitscont .contentbox .contentboxinner .tablebox .tableboxinner #rtfixedbox .cashGift, #defitscont .contentbox .contentboxinner .tablebox .tableboxinner #rtfixedbox .friendList {
  float: left;
  width: 10rem !important
}

#defitscont .contentbox .contentboxinner .tablebox .tableboxinner .lineboxdiv {
  width: 100%;
  background: linear-gradient( 180deg, #1e172c 0%, #2a193e 100%);
  display: flex;
}

#defitscont .contentbox .contentboxinner .tablebox .tableboxinner .lineboxdiv > div {
  width: 2.88rem;
  height: .91rem;
  line-height: .91rem;
  color: #fff;
  font-size: .27rem !important;
  text-align: center;
  border-right: .03rem solid rgba(65, 65, 65, 0.55);
}

#defitscont .contentbox .contentboxinner .tablebox .tableboxinner .lineboxdiv > div .img {
  width: .18667rem;
  height: .32rem;
  display: inline-block;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAMAAAD9GTxlAAAAdVBMVEUAAABmo/XBwt5npvjAwt7Awd3Awt3Awd1opvdopvdnpvbAwd3Awt7Cwt5npvhmpfe6xNhgn/+lvvJVleu/v9Vopvhopvdopvhopve/wt1npvfAwd2/wt3Bw95opvdnpfdopve/wt7AwNxnqvlmofdopvfAwt3oQuuNAAAAJXRSTlMAGOX57eTTz8q/pZWKbFo/GhANBgbu5NfTvLq6p6Gbg3tUUSoeCJE9rAAAAHNJREFUGNOtzMcBgzAUBNG1ySYH52yz6r9EkMQXKoB3m8vAGM9pC6e9kFkv1d84O0i+aLxtfbiodFUUQQ3UAZ3jHyd6UmQU9r7zYEt5tHeiHKHyhPj6+QPKtUrMCqkCxsPWE9Zw1XUfsOgSpZIOThPHDbQJynoUpsrXAqYAAAAASUVORK5CYII=) no-repeat;
  background-size: 100% 100%;
  margin-left: .18667rem;
  margin-top: .02667rem
}

#defitscont .contentbox .contentboxinner .tablebox .tableboxinner .lineboxdiv > div .imgsd {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAMAAAD9GTxlAAAAaVBMVEUAAADBwt5mo/XAwd2Mq+BnpvjAwt1opvdopvfAwt1npvfAw93Awt7Cwt5npvi/wd26xNhhp//ExOtopvhopvdopfdopvdnpvdopfa/wt3Bwt5npfdopvdnpPdmpvdnqvlmofdopvfAwt1ku5v/AAAAIXRSTlMA5RjRBvnsyr+7n5SKbFpRGg4N7uTY07qnp6CDe0M8Kh69V/OOAAAAa0lEQVQY063HVwLCIBBAwaeQ3mPvZu9/SAUE9wCZv8EbjRlJZiNi5jhbyVdlCS7iXcNa+WndOkk6GEQZyHVzmo3SsKatAuWinNnrFjyz/3Yv6NOyB8A9tserw24E9uRWE03HZSktyftQTDgfau0SMwLSmJkAAAAASUVORK5CYII=) no-repeat;
  background-size: 100% 100%
}

#defitscont .contentbox .contentboxinner .tablebox .tableboxinner .lineboxdiv > div .imgnone {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAYCAMAAAAS21dbAAAAUVBMVEUAAACenr+ZnbKYnbKZnbKZnbKYnbCSoKiZnbKYnLGZnbKanbKZnbKZnbKZnrKZnbKZnbKZnrKZnLKZnbGZnbOYnLKYm7GZnrCTnbGVlaqZnbKg/skeAAAAGnRSTlMAB/NG59FeC8q6tqSfl3vxr62OinV0XDcaGF3Mfb4AAABpSURBVBjTrc9JFoUgEEPRoCL2v7HP/hcqp+RA4dg7e7ME4rD2ROIs2biYpqXXxR4oxpATg0myZlT7LIvURQlUVCrgq/uH9xnFZ0eleez5GOzZ3vzAlh9ccVsoZiD40+uR9GRr9KZxcBAXIZ0OxUixZc0AAAAASUVORK5CYII=) no-repeat;
  background-size: 100% 100%
}

#defitscont .contentbox .contentboxinner .tablebox .tableboxinner .lineboxtext {
  background: #fff;
  height: 1.06667rem;
  border-bottom: .02667rem solid rgba(205, 209, 223, .6);
  border-radius: 0
}

#defitscont .contentbox .contentboxinner .tablebox .tableboxinner .lineboxtext div {
  font-weight: 500;
  height: 1.04rem;
  font-size: .26667rem !important;
  color: #30333e
}

#defitscont .contentbox .contentboxinner .tablebox .nonedat {
  width: 100%;
  height: 6rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

#defitscont .contentbox .contentboxinner .tablebox .nonedat .nonedatImg {
  width: 6.26667rem;
  height: 2.24rem;
  vertical-align: middle
}

#defitscont .contentbox .contentboxinner .Friendbox .tableboxinner {
  margin-left: .4rem
}

#defitscont .contentbox .contentboxinner .Friendbox .tableboxinner .ltfixedbox {
  min-width: 2rem
}

#defitscont .contentbox .contentboxinner .Friendbox .friendList .frienddeposit, #defitscont .contentbox .contentboxinner .Friendbox .friendList .lineboxtext {
  margin-left: 1.86667rem
}

#defitscont .contentbox .contentboxinner .nonemoretex {
  width: 9.4rem;
  height: 1.30667rem;
  color: #fff;
  font-size: .32rem !important;
  font-weight: 500;
  color: #7e88ad
}

#defitscont .contentbox .contentboxinner .topnoboard {
  float: left;
  width: 9.2rem;
  background: #fff;
  border-radius: .13333rem;
  margin-top: .26667rem;
  padding-top: .13333rem
}

#defitscont .toptitle {
  width: 100%;
  height: 1.17rem;
  font-size: .48rem;
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

#defitscont .toptitle img {
  width: 0.43rem;
  position: absolute;
  left: .4rem
}


#defitscont .collebox .lvtitle .ngblue {
  right: 0
}


#defitscont .collebox .monySoild {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: space-evenly !important;
  -webkit-justify-content: space-evenly !important;
  -ms-flex-pack: space-evenly !important;
  justify-content: space-evenly !important;
  margin-left: .53333rem;
  height: 1.92rem
}

#defitscont .collebox .monySoild .showdetdiv div {
  margin-top: .53333rem
}


#defitscont .collebox:nth-child(2) {
  padding: 0
}

#defitscont .colleboxac .tablebox .tableboxinner .lineboxdiv div:first-child {
  display: none !important
}

#defitscont .colleboxac .lvtitle {
  border: none
}

#defitscont .colleboxac .lvtitle .ngblue {
  -webkit-transform: rotate(180deg) !important;
  -ms-transform: rotate(180deg) !important;
  transform: rotate(180deg) !important
}

#defitscont .van-overlay, #defitscont .van-popup--bottom {
  right: 0 !important;
  left: 20rem;
  width: 10rem !important
}

#defitscont .van-popup--bottom {
  bottom: 1.30667rem
}

[data-v-9774ec9a] .van-toast {
  z-index: 9999 !important
}

.index-container .spgifuss[data-v-9774ec9a] {
  position: fixed;
  bottom: 1.7rem;
  right: .1rem;
  width: 1.5rem;
  height: 1.5rem
}

.index-container .hbpopclass[data-v-9774ec9a] {
  float: left;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 200
}

.index-container .hbpopclass .hbcontentsl[data-v-9774ec9a] {
  width: 9.86667rem;
  height: 12.56rem;
  background: url(/static/img/bgimg.a6fc96be.png) no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  position: relative;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%)
}

.index-container .hbpopclass .hbcontentsl .hongbaobtncont[data-v-9774ec9a] {
  float: left;
  width: 5.52rem;
  height: 7.33333rem;
  margin: 2.93333rem 0 0 2.13333rem;
  overflow-y: scroll
}

.index-container .hbpopclass .hbcontentsl .hongbaobtncont .hongbaobtncontinner[data-v-9774ec9a] {
  float: left;
  width: 100%
}

.index-container .hbpopclass .hbcontentsl .hongbaobtncont .hongbaobtncontinner .hbyanshi[data-v-9774ec9a] {
  float: left;
  width: 5.52rem;
  height: 2.18667rem;
  margin-top: .08rem
}

.index-container .hbpopclass .hbcontentsl .hongbaobtncont .hongbaobtncontinner .hbyanshiylq[data-v-9774ec9a] {
  float: left;
  width: 5.46667rem;
  height: 2.18667rem;
  background: url(/static/img/ylq.9efab72b.png) no-repeat;
  background-size: 100% 100%;
  margin-top: .08rem
}

.index-container .hbpopclass .hbcontentsl .xxbtn[data-v-9774ec9a] {
  float: left;
  width: 1.28rem;
  height: 1.28rem;
  margin-left: 4.26667rem
}

.index-container .hbpopclass .dkhbsssss[data-v-9774ec9a] {
  width: 7.17333rem;
  height: 8.45333rem;
  position: relative;
  top: 50%;
  margin: 0 auto;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  background: url(/static/img/hbimg.a1d1f8b4.png) no-repeat;
  background-size: 100% 100%
}

.index-container .hbpopclass .dkhbsssss .icoimg[data-v-9774ec9a] {
  float: left;
  width: .85333rem;
  height: .85333rem;
  margin: 1.12rem 0 0 5.22667rem
}

.index-container .hbpopclass .dkhbsssss .hbjinecont[data-v-9774ec9a] {
  float: left;
  width: 100%;
  margin-top: 1.17333rem
}

.index-container .hbpopclass .dkhbsssss .hbjinecont .hbtitle[data-v-9774ec9a] {
  height: .32rem;
  font-size: .32rem;
  color: #fff
}

.index-container .hbpopclass .dkhbsssss .hbjinecont .hbtitle[data-v-9774ec9a], .index-container .hbpopclass .dkhbsssss .hbjinecont .qbgsss[data-v-9774ec9a] {
  float: left;
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.index-container .hbpopclass .dkhbsssss .hbjinecont .qbgsss[data-v-9774ec9a] {
  height: .77333rem;
  font-size: 1.01333rem;
  font-weight: 600;
  color: #ffe9ac;
  margin-top: .24rem;
  margin-bottom: .16rem
}

.index-container .hbpopclass .dkhbsssss .hbjinecont .textcmnetdss[data-v-9774ec9a] {
  float: left;
  width: 100%;
  font-size: .32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #fff;
  line-height: .42667rem;
  text-align: center;
  margin-top: .66667rem
}

.index-container .hbpopclass .dkhbsssss .hbbbtn[data-v-9774ec9a] {
  float: left;
  position: absolute;
  width: 3.33333rem;
  height: 1.12rem;
  bottom: 1.65333rem;
  left: 1.92rem;
  background: url(data:image/png;base64,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) no-repeat;
  background-size: 100% 100%
}


.index-container .warpper .bottom-taps {
  display: flex;
  position: absolute;
  bottom: 0;
  border-top: .03rem solid rgba(255, 255, 255, 0.10);
  background: rgba(255, 255, 255, 0.10);
  width: 100%;
  justify-content: space-between;
  padding: .2rem .37rem;
}

.index-container .warpper .bottom-taps .van-swipe__track {
  background-color: #f5f6fd !important
}

.index-container .warpper .bottom-taps .bottom-taps-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #bbb;
}

.index-container .warpper .bottom-taps .bottom-taps-list img {
  width: .64rem;
}

.index-container .warpper .bottom-taps .bottom-taps-list p[data-v-9774ec9a] {
  font-size: 0.32rem;
}

.index-container .warpper .bottom-taps .tapsactive[data-v-9774ec9a] {
  color: #468FFF;
}

.readnums[data-v-9774ec9a] {
  margin-right: .26667rem;
  background: #f81b1b;
  padding: .02667rem .13333rem;
  color: #fff;
  border-radius: .26667rem;
  position: absolute;
  margin-left: .26667rem
}

.qrcode-container {
  position: absolute;
  z-index: 3000;
  left: .69rem;
  right: .69rem;
  top: 50%;
  transform: translateY(-53%);
  height: 13.35rem;
  text-align: center;
  background-image: url("/static/image/new/inviter/share-bg.png");
  background-size: 100% 100%;
  padding: 0 1rem;
  .qrcode-title {
    margin-top: 6.37rem;
    font-size: 0.64rem;
    font-family: HYLingXinJ;
    background: linear-gradient(0deg, #F5F6FF 0%, #E4E7FF 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-text-stroke: .03rem #fff;
    text-shadow: 0 0 2px #8792F5,0 0 2px #8792F5,0 0 2px #8792F5,0 0 2px #8792F5,0 0 2px #8792F5,0 0 2px #8792F5,0 0 2px #8792F5,0 0 2px #8792F5,0 0 2px #8792F5,0 0 2px #8792F5;

  }
  .time {
    font-size: 0.37rem;
    margin-top: .27rem;
  }
  .tag-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: .53rem;
    .tag {
      height: 0.72rem;
      line-height: .72rem;
      background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
      padding: 0 .35rem;
      border-radius: .11rem;
      margin: 0 .14rem .27rem;
    }
  }
  .qrcode-img {
    width: 2.08rem;
    height: 2.08rem;
    margin-top: .23rem;
  }
}

#InvitationLink {
  height: 100%;
  overflow: scroll;
  flex-direction: column;
  padding-bottom: 2.2rem
}

#InvitationLink, #InvitationLink .textcenter, #InvitationLink .toptitle {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex
}

#InvitationLink .textcenter, #InvitationLink .toptitle {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

#InvitationLink .toptitle {
  width: 100%;
  height: 1.17rem;
  font-size: .48rem;
  position: relative;
  flex-shrink: 0;
}

#InvitationLink .toptitle img {
  width: 0.43rem;
  position: absolute;
  left: .4rem
}

#InvitationLink .banner {
  position: relative;
  width: 9.46667rem;
  height: 2.53333rem;
  background-image: url(/static/img/bg-1.19dde362.png);
  background-size: 100%;
  margin: 10 auto;
  font-size: .37333rem;
  color: #0b1028
}

#InvitationLink .banner .banner-title {
  position: absolute;
  top: .54667rem;
  left: .57333rem
}

#InvitationLink .banner .banner-title img {
  width: .29333rem;
  height: .29333rem
}

#InvitationLink .banner .banner-count {
  position: absolute;
  top: 1.30667rem;
  left: .57333rem;
  color: #3084ff;
  font-size: .8rem;
  font-weight: 700
}

#InvitationLink .content {
  background: #fff;
  padding: 0 .38667rem
}

#InvitationLink .content .line-item {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border-bottom: .02667rem solid #d7ddeb
}

#InvitationLink .content .line-item .item {
  width: 50%;
  padding: .48rem 0
}

#InvitationLink .content .line-item .item .title {
  font-size: .32rem;
  color: #5d6b9d;
  margin-bottom: .10667rem
}

#InvitationLink .content .line-item .item .count {
  font-size: .42667rem;
  color: #0b1028
}

#InvitationLink .content .line-item .item-center {
  width: .01333rem;
  height: 1.06667rem;
  background: #d7ddeb
}

#InvitationLink .content .line-item .item-right {
  padding-left: .38667rem
}

.toptitle[data-v-6eb29ad0] {
  float: left;
  width: 100%;
  height: 1.17333rem;
  border-bottom: .02667rem solid #f4f4f4;
  font-size: .45333rem;
  color: #424653;
  background: #fff;
  font-weight: 600;
  position: relative;
  z-index: 100
}

.toptitle img[data-v-6eb29ad0] {
  float: left;
  width: .26667rem;
  height: .48rem;
  position: absolute;
  left: .48rem
}

.toptitle div[data-v-6eb29ad0] {
  font-weight: 400;
  font-size: .37333rem;
  float: right;
  width: 2.4rem;
  height: 1.30667rem;
  position: absolute;
  top: 0;
  right: 0
}

.pitsbox[data-v-6eb29ad0] {
  position: relative
}

.triangle[data-v-6eb29ad0] {
  position: absolute;
  bottom: -.16rem;
  right: .24rem;
  width: 0;
  height: 0;
  border-left: .26667rem solid transparent;
  border-right: .26667rem solid transparent;
  border-top: .26667rem solid #5e6da3
}

.pits[data-v-6eb29ad0] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  position: absolute;
  right: -.26667rem;
  top: -.8rem;
  width: 5.33333rem;
  height: .53333rem;
  line-height: .53333rem;
  padding: 0 .21333rem;
  border-radius: .16rem;
  background-color: #5e6da3;
  color: #fff
}

.pitsicon[data-v-6eb29ad0] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAABG5JREFUWEe9mGtsFFUUx/9nZ9tufTQx0k+CKJhUiF/AGBFpCEp8ANtpMK1WUai7W6pBko2S7hKjo9HuFE2qQkptZ8HwKA9j3AcSDTY1UvGRCCaC1ZhqakqiSKNZQLpsd465+2h229LdmQHm0yRz/r/7n7n3nnvOEAxeTZs+nsuS9LBOXE2MKhDNBnNFCkMUg85/sA0/g/GVPWn77P23nL8aGYKKCa6rOyhVzCl9HEQbCbi3GM14DNF3DO6QRv7s6epanyikLWjI4wstZ9A2AFWFYNM+Jwyyzt5gW210urjLGlqn9Dnso7F3ATRZMjJZvLfUEW/uUOrPT8Wd0lCj/3ClxIlPANxzhc1kcHzSLkmPdL7pPD2RP8lQxsxRy1NU8E14CHpyibblseHc0DxDXu/B8lhZWZ/hhVtw8MsG/FjqiC/Onb48Qx5/pJOZ15vgjwI4BqAaQIlB/R5NlZ/OasYNuTZHHyRd/9wgTOSeHntizNv59uozGcYhAA4jHCJydgdqhA4pQ4qi2IZHF54EeJ4hEBD71xGv/FCpv5TVeXzhUwzMN8IB8NtMR0WVoiwbSxnytISfYMI+gxARfuHGeLyyvb3+YpoTWsxEYkPYDLOY12pttbtShty+cD+A+w1DhIC5l8h2hMG3AVgLoNwMh4Fvg6q8iNwvR27HGA9mp88M7EppiJJV5PGFmxnYbhH6DwHHGFhpicO8gdy+8B4AT5kHURQ29mit8l+ultArRPSaaRZRjzB0HMACE5AEg1uCqvwOQCz0jf7QfInplAlWWsL4QRg6C+Bmg5Bh6FSnban5Jlfn9ocawbTDICs3fEQYigMoNQIhote7A07F1RJeJZVLvV2K8z+hd/lCOwm0zghrQmzclCEA58AYBGGGpsqzslC3LzwE4FarhsxMWXrKCfuDAblB3DdtjizUdf7eghkhPWtlUYOBF4KqLKpJkVwVAK9aNHTC0rZn4NGgKn+aMSRK01UWDe21khj5EiUrdwVWj4g66lxZ2QgI/cS4xcThml4CzM1Wjo5fNFW+M727wncQ+G5NrT3gbgmvAWG3iS/FsNPc7OH6Zaa4KppD4N3dau0zeXnIF2kAuAvADUWDMoEM9AdVuTpTfkTqmfiAQcg+TZWfzKRYcvmja4hZdCk3GeSkwonR0N0m77dSoMXB8BLRGQa/BGCRGSNpDQ3MdBy/S1EUfbyEdfsiDwDcax5qXsk22/JgqzM1dl6R7/aHO8B4zjzahJKwXQvIz2eVeYZEtyqNxr64Vm2QqBKvu1CydOvWFeI8TU/exHfKNIpi16W29NW7aCBJ9qU7Ayv+zh1jyla66cXoDL1EP3y1WmnxZRKUXCmS6sQXvuY/GwjYlnBUbPpAWSaay0lXwd8xovmz6fp7Zo+DnLXxU9KGDTta5b7plkFBQ0IsGsnTFxeI5LkRoPuMrSv+mkHtsxwnPhJ5ppC2KEO5kGd9h+ZISD7EwBIw5oEwG8D1mZjzAA0BPADQUdhxRHuj5vdCJnKf/w+146qW0RmFIgAAAABJRU5ErkJggg==) 50% no-repeat;
  background-size: 210%;
  margin-left: .05333rem;
  width: .34667rem;
  height: .34667rem;
  display: inline-block;
  background-size: cover
}


#defitscont .collebox .lvtitle[data-v-6eb29ad0], .textleft[data-v-6eb29ad0], .yxdivbox .selediv[data-v-6eb29ad0] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.textright[data-v-6eb29ad0], .yxdivboxasd[data-v-6eb29ad0] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.memberpop[data-v-6eb29ad0] {
  width: 100%;
  height: 100%
}

#defitscont {
  float: left;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: #000;
  color: #fff;
  font-family: PingFang SC;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 2rem;
  .contentbox {
    flex: 1;
    overflow: auto;
  }
}

#defitscont .contentbox {
  width: 100%;
  height: calc(100% - 2.66667rem);
  overflow-y: scroll
}


#defitscont .contentbox .contentboxinner .rtfixedboxinner[data-v-6eb29ad0] {
  width: 21.86667rem
}

#defitscont .collebox {
  width: 100%;
  .listTag {
    background: rgba(255, 255, 255, 0.10);
    border: .03rem solid rgba(255, 255, 255, 0.10);
    border-radius: .21rem;
    margin-top: .27rem;
    padding: .27rem;
    .tab-list {
      height: 1.07rem;
      background: rgba(255, 255, 255, 0.10);
      border: .03rem solid rgba(255, 255, 255, 0.10);
      display: flex;
      border-radius: .21rem;
      margin-bottom: .32rem;
      .tab-item {
        height: 100%;
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.37rem;
        &.active {
          background: linear-gradient(to bottom, #2E0B71 40%, #7214D7);
          border-radius: .21rem;
        }
      }
    }
  }
}

#defitscont .collebox .lvtitle[data-v-6eb29ad0] {
  float: left;
  width: 9.2rem;
  margin-left: .4rem;
  height: 1.33333rem;
  font-weight: 700;
  color: #30333e;
  font-size: .37333rem;
  position: relative
}

#defitscont .collebox .lvtitle div[data-v-6eb29ad0] {
  width: .10667rem;
  height: .42667rem;
  background: -webkit-linear-gradient(left, #25deff, #0084ff);
  background: linear-gradient(90deg, #25deff, #0084ff);
  float: left;
  margin: 0 .21333rem 0 0
}

#defitscont .collebox .lvtitle img[data-v-6eb29ad0] {
  width: .26667rem;
  height: .16rem;
  position: absolute;
  right: 0;
  -webkit-transition: all .15s linear;
  transition: all .15s linear;
  -webkit-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  transform: rotate(0deg)
}

#defitscont .collebox .showdetbox[data-v-6eb29ad0] {
  float: left;
  width: 9.2rem;
  margin-left: .4rem;
  height: 1.73333rem;
  border-bottom: .02667rem solid #c6c6ca;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex
}

#defitscont .collebox .showdetbox[data-v-6eb29ad0]:last-child {
  border: none
}

#defitscont .collebox .showdetbox .showdetdiv div {
  width: 100%;
  font-size: .37rem;
  font-weight: 500;
  text-align: left;
  padding: 0 .27rem;
}

#defitscont .collebox .showdetbox .showdetdiv div:nth-child(2) {
  color: #999999;
  font-size: .32rem;
  text-align: right;
}

#defitscont .collebox[data-v-6eb29ad0]:nth-child(2) {
  background: #fff;
  overflow: hidden;
  min-height: 100%
}

#defitscont .colleboxac[data-v-6eb29ad0] {
  height: 1.30667rem;
  overflow: hidden
}

#defitscont .colleboxac[data-v-6eb29ad0]:nth-child(2) {
  min-height: 1.30667rem
}

#defitscont .colleboxac .lvtitle img[data-v-6eb29ad0] {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg)
}

#defitscont .bottom[data-v-6eb29ad0] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 0 .26667rem
}

.yxdivbox[data-v-6eb29ad0] {
  width: 94vw !important;
  display: -webkit-box !important;
  display: -webkit-flex !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.yxdivbox input[data-v-6eb29ad0] {
  margin-left: .26667rem;
  width: 80% !important;
  border: none;
  border-radius: .26667rem
}

.yxdivbox .timer[data-v-6eb29ad0] {
  width: 80%;
  margin-left: .21333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.yxdivbox .timer .selediv[data-v-6eb29ad0] {
  border-radius: .26667rem
}

.tablebox[data-v-6eb29ad0] {
  width: 100% !important;
  overflow: hidden !important
}

.tablebox .tableboxinner[data-v-6eb29ad0] {
  width: 100vw !important
}

.tablebox .ltfixedbox[data-v-6eb29ad0] {
  width: 1.86667rem !important
}

.tablebox .ltfixedbox .lineboxdiv[data-v-6eb29ad0] {
  width: 100% !important
}

.rtfixedbox[data-v-6eb29ad0] {
  margin-left: 1.86667rem;
  width: calc(100% - 1.86667rem);
  overflow-x: scroll;
  padding-right: .26667rem
}

.rtfixedbox .lineboxdiv[data-v-6eb29ad0] {
  width: 100% !important
}

.rtfixedbox .lineboxdiv div[data-v-6eb29ad0] {
  width: 2.98667rem !important;
  -webkit-box-orient: horizontal !important;
  -webkit-box-direction: normal !important;
  -webkit-flex-direction: row !important;
  -ms-flex-direction: row !important;
  flex-direction: row !important;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  background-color: #98afec
}

.rtfixedbox .lineboxtext div[data-v-6eb29ad0] {
  background-color: #fff;
  border-bottom: .02667rem solid #eee
}

.nonedat[data-v-6eb29ad0] {
  width: 100% !important;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column
}

.nonedat img[data-v-6eb29ad0] {
  margin-top: .53333rem
}

#defitscont .ng_poker_pop[data-v-6eb29ad0] {
  left: 100vw;
  width: 100vw
}

#defitscont[data-v-6eb29ad0] .van-overlay {
  left: 100vw !important
}

.yxdivboxasd[data-v-6eb29ad0] {
  float: left;
  width: 9.2rem;
  height: .93333rem;
  margin-left: .4rem;
  margin-top: .4rem;
  margin-bottom: .4rem
}

.yxdivboxasd div[data-v-6eb29ad0] {
  width: 2.53333rem;
  height: .93333rem;
  background: #fff;
  border: .02667rem solid #d9ddeb;
  border-radius: .13333rem;
  font-weight: 700;
  color: #373c4a
}

.yxdivboxasd .chaxunbtn[data-v-6eb29ad0] {
  float: left;
  width: 2.53333rem;
  height: .93333rem;
  background: -webkit-linear-gradient(left, #23bffc, #198bf9);
  background: linear-gradient(90deg, #23bffc, #198bf9);
  border-radius: .13333rem;
  font-weight: 700;
  color: #fff;
  font-size: .37333rem;
  margin-left: .26667rem
}

.yxdivbox[data-v-6eb29ad0] {
  margin: .26667rem .4rem
}

.yxdivbox .selediv[data-v-6eb29ad0] {
  float: left;
  width: 100%;
  height: 1.06667rem;
  background: #f5f6fa;
  border-radius: .26667rem;
  border: none;
  padding-left: .4rem;
  position: relative;
  font-weight: 500;
  color: #30333e;
  font-size: .34667rem;
  outline: none
}

.yxdivbox .selediv img[data-v-6eb29ad0] {
  width: .24rem;
  height: .13333rem;
  position: absolute;
  right: .29333rem;
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg)
}

.tiemselediv[data-v-6eb29ad0] {
  width: 4rem;
  float: none
}

.tablebox[data-v-6eb29ad0] {
  float: left;
  width: 100%;
  overflow-x: scroll;
  background: #fff
}

.tablebox .tableboxinner[data-v-6eb29ad0] {
  float: left;
  width: 100% !important;
  position: relative
}

.tablebox .tableboxinner .ltfixedbox[data-v-6eb29ad0] {
  float: left;
  width: 1.86667rem;
  position: absolute
}

.tablebox .tableboxinner .ltfixedbox .lineboxdiv[data-v-6eb29ad0] {
  width: 1.97333rem
}

.tablebox .tableboxinner .ltfixedbox .lineboxdiv div[data-v-6eb29ad0] {
  width: 1.86667rem
}

.tablebox .tableboxinner .rtfixedbox[data-v-6eb29ad0] {
  float: left;
  width: 8.13333rem;
  overflow-x: auto;
  margin-left: 1.86667rem
}

.tablebox .tableboxinner .rtfixedbox .rtfixedboxinner[data-v-6eb29ad0] {
  float: left;
  width: 1056
}

.tablebox .tableboxinner .lineboxdiv[data-v-6eb29ad0] {
  float: left;
  width: 100%;
  background: #98afec;
  height: .8rem
}

.tablebox .tableboxinner .lineboxdiv > div[data-v-6eb29ad0] {
  float: left;
  width: 3.52rem;
  height: .8rem;
  font-weight: 500;
  color: #fff;
  font-size: .32rem
}

.tablebox .tableboxinner .lineboxdiv > div .img[data-v-6eb29ad0] {
  width: .18667rem;
  height: .32rem;
  display: inline-block;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAYAAADKx8xXAAABxUlEQVQ4T+WUP2gTcRTHv+/ypz1NCh10qGAxUHBwcMh4HAHRiA5dFIuxkhaJGdStLlJwyKRjFTxcNMiZsQ7Gf5Vcz9DFxVEQD4TQQYORSLikMffkrknMn0u4zD5+y3vv+/n9fvze7z2Ci6WemkeFAL0BuFpvTMefrNCvQRkNBlZfcDhYq+8AONHOad/KpbOvbi00erV9YErhAIXrLwk43Sti8DPl8oHlkWBaNR8DuOZ2fWZklIS43sl1T0yr5h0AGTfIjrG9GEklIWZt3wGvP29cIrZUAMIocB+mPVh8TrkivqeUakoCsAVgahz0L0cV9pNEadUsATjiDWqrGB9tsAAgNhnIOcJdFpLztcNBPw3V1G0zga3Wo6vh757Ebhv8F6C2/fUhgEUib6/KtgGbpOnGT4BnJ6ojUKaCblwgcA6AzyPcgsUXnXLounHDAm94AQXQTVmOPOjWUdONewCvjYfpfkyO3O62ldMyzKR9MFQCllx/ClFWlo4liYj7QNvJ579MiSHBHh2n+mDGu9DByvloNNocmgCdQLH4I/ynVdVBOOnEGJ/8vhlZkg79HjlzOom3xc9zQSvw2ml5XzN+Rjq+O3j9v6KblK2zZiqwAAAAAElFTkSuQmCC) no-repeat;
  background-size: 100% 100%;
  margin-left: .18667rem;
  margin-top: .02667rem
}

.tablebox .tableboxinner .lineboxdiv > div .imgsd[data-v-6eb29ad0] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAYAAADKx8xXAAABxklEQVQ4T9WUPUgjYRCG39nEeFFjIWhxB3cQECwsLFIuawr/0EYE8VBPooim8K7TRgQLKy21cLFRkVWuOQRPxTvPuIZrbCwFMSCIhT/4h2yiZkd21RiTNWxKp9v3e59vhpn5lmARa+Hdj654zioAunXc1daIZUepNkoVwuETz338SgWhwjxj7DgdhZIoFl8ne1+By8t7uXkFwhKAqlcXMv4U5J83+Hy+u2c9ATIzhbYiCgFfrcon0Eyl5A2kgSE1MgpwvxX0otGYX/IOGN9mRlWN9Ong8czQ46kA+i5J3gn6t7nfJBB+AnDYAQHEoXMzhdT9MwBFNqEnG5/Q5lZkgnVuJKK00VhdxkYQ/7Jltu5ydjUm3O8q4zALgS83JS6nva4KrMcnOzzHFFS0DQD+rHrEvGCAhwA+ZQdim3oUTRSAvwBy7cF0zk4SzXH0zsdaiHXF3OEMwaBb6Fwvt7vXE3MMKtoggJG3ODb+BYyA3OaeTTyrZ3NQ0aYAdFvvKEbkNvdQ2kM2hB6Zc8gT/U1AdTLM4Dm5Ne9bspa2cl2L7HHdRP8DKH8yhg5OD+tWfpTGMoJm5hnts+DEGgiX0diH2ulOukgt/wFz1ZSqgpmbTwAAAABJRU5ErkJggg==) no-repeat;
  background-size: 100% 100%
}

.tablebox .tableboxinner .lineboxdiv > div .imgnone[data-v-6eb29ad0] {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAYCAMAAAAS21dbAAAAilBMVEUAAAD///+qqqqZmZmSkrafn7+LoqKdnbGVlaqTnbGZnrCYm7GZnbOYn7OYm7GYnbCYnLKZnbOZnrKZnbGZnLKYnLKZnbKYnbKanbKZnbKanbKZnrKZnbKZnLGZnbKYnbGYnLGZnbKZnLGZnbGZnbOZnbKZnbKZnbKZnbKZnbKZnbKZnbKZnbKZnbJ2D4lVAAAALXRSTlMAAQMFBwgLDRgaN0VGSlxedHV7io6VmZ6foqatr7S2uLrKz9LS5OXq8fP5/f5l/LEEAAAAeklEQVQYGa3BhwGCMABFwYcIFlQUexe7mL//ekIIZQDvsAa3e59G7yqlIRX/otyxg7OWtaKUyEkoxEaOiYEoUy2L4KWWJxyMambP/3WDBnBSS+rxUMs7YPhRLRsB40zOd0IhNipNKc1kzakslNt6VLyddPZp+MtNiPUDcz4a85MLzYEAAAAASUVORK5CYII=) no-repeat;
  background-size: 100% 100%
}

.tablebox .tableboxinner .lineboxtext[data-v-6eb29ad0] {
  background: #fff;
  height: .8rem;
  border-bottom: .02667rem solid rgba(205, 209, 223, .6);
  border-radius: 0
}

.tablebox .tableboxinner .lineboxtext div[data-v-6eb29ad0] {
  font-weight: 500;
  height: .8rem;
  color: #30333e
}

.tablebox .tableboxinner .lineboxtext .check[data-v-6eb29ad0] {
  color: #198bf9
}

.nonemoretex[data-v-6eb29ad0] {
  line-height: 1.06667rem;
  width: 100%;
  text-align: center;
  margin-bottom: .8rem
}

.textcenter[data-v-3ec249bd], .toptitle[data-v-3ec249bd] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.toptitle[data-v-3ec249bd] {
  width: 100%;
  height: 1.17333rem;
  background-color: #fff;
  font-size: .48rem;
  color: #0b1028;
  font-weight: 600;
  position: relative
}

.toptitle img[data-v-3ec249bd] {
  width: .26667rem;
  height: .48rem;
  position: absolute;
  left: .4rem
}

#ng_poker_record[data-v-3ec249bd] {
  height: 100%;
  background: #f4f4f4
}

#ng_poker_record .content[data-v-3ec249bd] {
  width: 100%;
  height: calc(100% - 2.66667rem);
  overflow-y: scroll
}

#ng_poker_record .content img[data-v-3ec249bd] {
  width: 100%
}

.textcenter[data-v-64773ba1], .toptitle[data-v-64773ba1] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.toptitle[data-v-64773ba1] {
  width: 100%;
  height: 1.17333rem;
  background-color: #fff;
  font-size: .48rem;
  color: #0b1028;
  font-weight: 600;
  position: relative
}

.toptitle img[data-v-64773ba1] {
  width: .26667rem;
  height: .48rem;
  position: absolute;
  left: .4rem
}

#ng_poker_record[data-v-64773ba1] {
  height: 100%;
  background: #f4f4f4
}

#ng_poker_record .search_part[data-v-64773ba1] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  padding: .53333rem .53333rem;
  background: #fff;
  box-sizing: border-box;
  margin-bottom: .16rem
}

#ng_poker_record .search_part .search[data-v-64773ba1] {
  position: relative;
  -webkit-box-flex: 3;
  -webkit-flex: 3;
  -ms-flex: 3;
  flex: 3;
  width: 6.94667rem;
  height: .93333rem;
  background-color: #f5f6fa;
  border-radius: .10667rem;
  margin-right: .16rem
}

#ng_poker_record .search_part .search input[data-v-64773ba1] {
  border: none;
  background-color: #f5f6fa;
  width: 6.94667rem;
  height: .93333rem;
  padding: 0 .26667rem
}

#ng_poker_record .search_part .search img[data-v-64773ba1] {
  position: absolute;
  right: .26667rem;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  width: .37333rem
}

#ng_poker_record .search_part .btn[data-v-64773ba1] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: .93333rem;
  background-color: #3084ff;
  border-radius: .10667rem;
  line-height: .93333rem;
  text-align: center;
  color: #fff;
  font-size: .37333rem
}

#ng_poker_record .content_part[data-v-64773ba1] {
  padding: 0 .53333rem;
  background-color: #fff
}

#ng_poker_record .content_part .content_item[data-v-64773ba1] {
  width: 100%;
  height: 1.33333rem;
  border-bottom: .02667rem solid #eee;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: .37333rem;
  color: #0b1028
}

#ng_poker_record .content_part .content_item .item_left[data-v-64773ba1] {
  color: #5d6b9d
}

#ng_poker_record .content_part .content_item .item_left .tip[data-v-64773ba1] {
  font-size: .26667rem;
  color: #ff4636;
  text-align: center
}

.ng_poker_pop_record[data-v-64773ba1] {
  width: 100vw;
  left: 300vw
}

.index-container .warpper[data-v-c27a3f14] {
}

.index-container .warpper .bottom-taps[data-v-c27a3f14] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: fixed;
  height: 1.30667rem;
  bottom: 0;
  border-top: .02667rem solid #fff;
  box-shadow: 0 0 .53333rem 0 rgba(102, 118, 165, .15);
  width: 100%;
  background: #fff;
  padding-top: .13333rem;
  border-radius: .26667rem .26667rem 0 0;
  -webkit-box-pack: space-evenly;
  -webkit-justify-content: space-evenly;
  -ms-flex-pack: space-evenly;
  justify-content: space-evenly
}

.index-container .warpper .bottom-taps .van-swipe__track {
  background-color: #f5f6fd !important
}

.index-container .warpper .bottom-taps .bottom-taps-list[data-v-c27a3f14] {
  width: 25%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  color: #6b7db2
}

.index-container .warpper .bottom-taps .bottom-taps-list img[data-v-c27a3f14] {
  width: .58667rem
}

.index-container .warpper .bottom-taps .bottom-taps-list p[data-v-c27a3f14] {
  line-height: .58667rem;
  height: .58667rem;
  margin: 0 0
}

.index-container .warpper .bottom-taps .tapsactive[data-v-c27a3f14] {
  color: #2385ff
}

.slide-left-enter-active, .slide-left-leave-active, .slide-right-enter-active, .slide-right-leave-active {
  will-change: transform;
  -webkit-transition: all .12s;
  transition: all .12s
}

.slide-right-enter {
  opacity: 0;
  -webkit-transform: translateX(-100%);
  -ms-transform: translateX(-100%);
  transform: translateX(-100%)
}

.slide-right-leave-active {
  opacity: .8
}

.slide-left-enter, .slide-right-leave-active {
  -webkit-transform: translateX(100%);
  -ms-transform: translateX(100%);
  transform: translateX(100%)
}

.slide-left-enter {
  opacity: 0
}

.slide-left-leave-active {
  opacity: .8;
  -webkit-transform: translateX(-100%);
  -ms-transform: translateX(-100%);
  transform: translateX(-100%)
}

::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0
}

.hyplan .botdivbox .navbtn .btntext, .hyplan .nonemoretex, .hyplan .tablebox .tableboxinner .lineboxdiv > div, .hyplan .tipscover .addbtn, .hyplan .toptitle, .hyplan .toptitle div, .hyplan .yxdivboxasd div, .textcenter {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.hyplan .yxdivbox, .hyplan .yxdivbox .selediv, .textleft {
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start
}

.hyplan .yxdivbox, .hyplan .yxdivbox .selediv, .hyplan .yxdivboxasd, .hyplan .yxdivbox span, .textleft, .textright {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.hyplan .yxdivboxasd, .hyplan .yxdivbox span, .textright {
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end
}

.hyplan {
  float: left;
  width: 100%;
  height: 100%;
  background: #fff;
  padding-bottom: 1.33333rem
}

.hyplan, .hyplan div {
  box-sizing: border-box
}

.hyplan div {
  -webkit-overflow-scrolling: touch
}

.hyplan input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none
}

.hyplan .tipscover {
  float: left;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 400;
  background: rgba(0, 0, 0, .6)
}

.hyplan .tipscover .fingerbtn {
  float: left;
  width: 3.54667rem;
  height: 2.64rem;
  position: absolute;
  right: .88rem;
  bottom: 4.10667rem
}

.hyplan .tipscover .addbtn {
  float: left;
  width: 2.53333rem;
  height: .93333rem;
  background: rgba(241, 242, 249, .1);
  border: .02667rem solid #fff;
  font-size: .37333rem;
  font-weight: 700;
  color: #fff;
  position: absolute;
  right: 1.26667rem;
  bottom: 2.72rem;
  border-radius: .13333rem
}

.hyplan .toptitle {
  float: left;
  width: 100%;
  height: 1.30667rem;
  border-bottom: .02667rem solid #f4f4f4;
  font-size: .45333rem;
  color: #424653;
  background: #fff;
  font-weight: 600;
  position: relative
}

.hyplan .toptitle img {
  float: left;
  width: .26667rem;
  height: .48rem;
  position: absolute;
  left: .48rem
}

.hyplan .toptitle div {
  font-weight: 400;
  font-size: .37333rem;
  float: right;
  width: 2.4rem;
  height: 1.30667rem;
  position: absolute;
  top: 0;
  right: 0
}

.hyplan .contentbox {
  height: calc(100% - 1.44rem);
  overflow-y: auto
}

.hyplan .contentbox, .hyplan .contentbox .contentboxinner, .hyplan .routerview {
  float: left;
  width: 100%
}

.hyplan .routerview {
  height: 100%
}

.hyplan .botdivbox {
  float: left;
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  height: 1.30667rem;
  background: #fff;
  box-shadow: 0 0 .26667rem 0 rgba(127, 144, 211, .3);
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around
}

.hyplan .botdivbox .navbtn {
  float: left;
  width: .64rem;
  height: 100%
}

.hyplan .botdivbox .navbtn .img {
  float: left;
  width: .53333rem;
  height: .53333rem;
  margin: .21333rem .05333rem .13333rem .05333rem;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAaVBMVEUAAACZnbKVlaOZnbKZnLKXmLCZnbKZnbKZnbKZnLGYnbKZnbKXm7CYnLOZnbKUlLOZnbKZnLKanrCZnLCWlrSZnbOYnbKZnbKYnbKXnbGYnbKWmrCXnbKYnLKanbOanbKYnbKZnbKZnbL44pfLAAAAInRSTlMA7gSZiBX5lnnmt7AeQzwH+6xENwugjdbTW1I6JKbgWldwNuK/KAAAATlJREFUOMudleuSgyAMhQOCQHV3vVStl17W93/IXTtgSsAO0/Mrhg8jZ2IAX62uL6zK2aXWLRyqFGZ9kRFlFJMqX4lyJUNuZGtEbCQYz9YDZfyVO5/WQ53OyHHCERLfSevS6vs5/HwxTYWfuVtf/POKLSf8s8tI4R7AkrR4mfucVe85X9K9CnYp+j2GcFHScJgDH6KuzaDxoQOiDtc0FCGHuqK5MLjwykOQ7+QAzG2xHCFdQQaVjSREJe1yBc7uJQ4uDtxL33oRFhb9bS89oAWui6W0vfqDawMUFGy3sKVgAZqC31v4RUENcxo4AzcpoOEAIgUU2Lhvwbz0ummh4IL95/1cHQU7/+eCu9tYT03T/D7d+A+m2uXH1AGQPFLShxSKqyNO0YZ+xAfpI200Z/LDYU+vjypyffwBoQx12mCjDQAAAAAASUVORK5CYII=);
  background-repeat: no-repeat;
  background-size: 100% 100%
}

.hyplan .botdivbox .navbtn .btntext {
  float: left;
  width: 100%;
  height: .32rem;
  font-weight: 500;
  color: #6d7683;
  font-size: .29333rem
}

.hyplan .botdivbox .navbtn:nth-child(2) .img {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAb1BMVEUAAACZnbKWnK+ZnLGZnLOZnbKZnbKXma+UlKWYnbKZnbOYnLGZnbKZnbKZnbKZnbKZnbKYnrOYnbKZnbKZnLOZnLKZmbOZnbOanbKZnbGZnLKZnLGZnbOZnLOZnbOYnbKYnbGYnLKZmaqSpLaZnbJEYsLbAAAAJHRSTlMA+SDmie2XFgRamjit8dbSdyW4fTDMCrRJ2aOTa1BBK8G6Dw46X041AAABPElEQVQ4y5XVaZODIAwG4JeKeB9UV+322iP//zfuUSdNpI7j800HCSEQoRVt2VTGxE3ZFlh1sBEJkT3glcQZWjAuQSCL6YU4g5bmtCJPIQxHWnUcxHxyXDjyOaeKG8o5D9owZ5SofE0++f7S6Nwfu+TULvePVVuS3H89jJyvx+xdhfmrkdXr5kKpOlkAqr4T2IdaEVCQxJEXsalAR9IN7JOkDiVJlsd9VySVqEmq+AhaUmpUixfzyAtpFQxpcevTr2kMzjAP3GAQkxY1b7+aaBlIJ2Osx8xbo5Mp5ZOH4Gu1PZ2ImkBJRPxOlvCKhassYcqfnRA4cTBZgjMCZy6tPLgtAq08uHC83iXO1KnLZVxW3P1hdu9vWW74cu26rtsNYH9LwTDSqnGAkDpa4dLdjXS7Ne9v9uHvowp/Hz8R6IankTTgWAAAAABJRU5ErkJggg==)
}

.hyplan .botdivbox .navbtn:nth-child(3) .img {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAYFBMVEUAAACZnbOZnbKYmrGXm66ZnbKZnbKZnbKZnLCUlKCYnbKZnbKanrCYnbKZnbKZnbKZnLGYnLGYnLKZnbOYmLOYnbOWnLCanbOZnbKanLKZnLKXnLGYnLKYnbGYm7GZnbK2PDKIAAAAH3RSTlMA+O4eFerXlzgE3q9Et3pa5oqImglVGY3NY009v6tc/jgyPQAAAT5JREFUOMuVVdm2gjAMnFboctEiKOj1Lvn/v7RUoItCYV7I4QydZBJSxFCmEpxYKSqjsIhDc6YA5+bwkVZIRgmYLN55NacP4HVC0xdawEWHvOuJFnG6BudZ3grTn5nqpupzHZRBPfrCc0T+cklSFtL1Y/a5A9R8SA903vmhRw1NKK3CbYy/bUqlP7K1xKC/lXVUuOgXwF/YdyuWlKcmqY5CKJiovP4lboA+EHZvqrgLTvyuMb33WYkx8kX8MAX8UwwBnnhrsztaYZ56Dhb62rbtAwMeNrpFzIh4iEc+JpahO8cBsGkOzy6WFpSAAf7roJhqG7GC2ZajgdpGVNDBUHwNEJZzd1E4FNqP2WqOjR/cVSJzSck8Ufqfa5XIi32/a34B7F4p+SXloeUST2rE6PKLNL+a9y/79Pog/n59PAHV8YCnRtQscgAAAABJRU5ErkJggg==)
}

.hyplan .botdivbox .navbtn:nth-child(4) .img {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAb1BMVEUAAACZnbKZnLGZnbKZnbKYnbOZnbKZnbGZnbKZnbKZnLKZnbKZnbKYnbKZnbKZnbKZnbKXm7CZnLGYnLCXl66ZnbKYnbOZnbKZnbGXm7CYnbGZnbKZnbKYnbKYnbOZmbOYmLCZnbKZnbKZnLOZnbJKcRizAAAAJHRSTlMAy6pnw4/V+oixpaztupdxeh7mNRbQmktAOlvvtGBZCivj4FBAMn1EAAABhUlEQVQ4y52V2ZaDIAxAg1KUutRqrWu17eT/v3EGgSFux87cp5zjVUwIAeYUmSfiIOiElxWwyzXMkZCH103tlga4IEhva6+NcYO4XXp33OEOlDHBXZKRiNRbm6t1D1cf8IDB1EXnG0SeRiJKGwY6d12lFCc8sJQMLD1OpNN+mDqfoTopGuAJ1FNYQWQqr/YoRCOayAfG4TKFoRJNBJATUdbciryWRMwBGiRiBa0VH1ARERvIqMgfpRXLB6NiBhI/+UeUIJxY+Iqnyvo5hYUTBcTuHYsQ6ybowHUr40zBS0ThQkNAxNI8FYgv8cMbY+FEt3S/XLrCk0u1o8k0JpmE/4pnlwwpz8mUh7O1KCGjIveFE6+Xmha8oWINrRYv6CuXbiHkRIzqxIrMU7xcU0C49Y8ZzglnjfulG1d/MSwk+kViG3f7KIipze5Y25qks8NlT1SPKBky7418frigxQPaTwfA30cKjP2+149ASfe8FBYM24N0+O9oPh72q+sjEp26PqLl9fENsrh9//ui3YgAAAAASUVORK5CYII=)
}

.hyplan .botdivbox .navbtn:nth-child(5) .img {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAdVBMVEUAAACZnbGZnbOZnbKYmbOXnKKZnbKZnLGZnLKZnbKXm7CVmLCZnbKYnbKYnbKYnbKYnbGXnLGZnbKZnbKZnbKZnbOZnbKXm7GZnbKZnbKanrCWnLGZnLCZnbKZnbKZnbKVmq+ZnbKXnrKZnrOZnrOWnrSZnbK95gczAAAAJnRSTlMA+oDtFwWX5ol6Hgnw1JpcuSrAq9izrzqRVkQ/N/PgyxDPTp1yIsOKawQAAAFYSURBVDjLlZXpdoMgEIWvIuCeuiWm2dN23v8RSxtCkOXk+P3Uz4PcGQYsORZDUycJa4biiChlLslC5iVCZCIhh0Rk8NgwCsA2jsZbitByWFQfFOWjgoHbnm9yIzrrurRmH/SGjc6FvRPZIyVBDjJ1PxVQlG7OTYncTb4EvIf9FUhJ8dWTIQcgl962wkMc7XQlsAsVIqUzI4HrSE92KEhzyP7AP2ld/Uj6xsGIBbakgUVKhZJOGXrzR2jCIh0wUfqqxQgWESclXdCRpkYSEZmSGLhJMirWSjxZYnTpHnu6oTRLRzdzx0CzkjVjLJ4WXZJ0GF7xFCbST8VOiyd+bWhWsnnrlnDWJbycqee8f5XQa4rp2RS3CrPVFH6bXbKHKO+CDHmocc8dUq9xg0ehzkdaIlYcrjXH9f0AWD9SUE1k4wdr4CLmCY4l+/Ag3a8ZzeuHvX991P718QvfR5LVF0t5oAAAAABJRU5ErkJggg==)
}

.hyplan .botdivbox .navbtnac .img {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAA/FBMVEUAAAAAvf8Hsf8AuP8Atv8Jrv8Isf8Irf8Guv8Bz/8Jq/8Gtv8Ht/8Jr/8Gt/8Dx/8GuP8Fuv8Hsv8Ir/8Gs/8IsP8Atf8Cyf8EwP8FvP8FvP8Ev/8Awf8Gvf8IsP8Kq/8B0P8BzP8EwP8Jr/8KrP8Bz/8Gu/8B0P8Kqv8Irv8Jrf8Ew/8HtP8Jr/8Jqv8A0f8GuP8Guf8Ir/8Czv8A0P8Jq/8Gu/8A0P8Azf8Irv8Dwf8JrP8Dwv8GsP8A0f8HuP8Itv8Itf8Jrv8Jrf8Hsf8Hs/8Axf8Jrf8Isv8Gu/8Jr/8Gvv8ItP8Dx/8Cy/8Htv8HuP8ExP8Bz/8Ewf8eQUUtAAAAR3RSTlMABDsIFphDRIv7+/rt5tW4sJ2JejceD5qYlo+GHvr67+3t7e3t5ubT07i0sK+srKunpKCXiYl7eFtbWldUUDck4OB1cCclILR+nFsAAAGNSURBVDjLjZLXcsIwEEXXBocOBtuh9957b+mFEJKQ//+XoFgyki0znKfV3jNej7TAIGym3WrO48lVu9ONAHa8jMpHivIoxdWcQ8/RhGfotHqz/IFDfgYsQvRgQ5T5VUfo05aQg/oe8fjm+ZvRn4vEiLf4ZWiuVk22s8D3UvigSaJekmkV9FuKMU03gNX8H55K060EYBJ0N43eyP1OEQeDBN1HcyqMRxGnggqASB3DwBCmIhEmjGdrTkD+JvTBQt8IZQiSssdZVKFH0iD4v3Rk4rGmjGM/+HDlBC5OHPsMccsXt4bo3+vcuSPWwRH3PY79ENwb4Pj2BN7ncxaElllUUamaxRYobwa6KKLyRhfPmQLidaIIQuAaMQAAkWtEdCNaZofBIiqxSJKMho4SOT6bxSeSSPorFfFxYBYHOCji953vMO21y+V6RNXDqVi3SX8OGOn1IhIQhPolr04toKNh7zUczJ5ItnMFYFmWeFppydllyWvWvBJ/77VxgNYCYw1sUZVOLev1ZmsdRWWTPw3AAcWIrVDSAAAAAElFTkSuQmCC)
}

.hyplan .botdivbox .navbtnac .btntext {
  color: #68a6f7;
  font-weight: 700
}

.hyplan .botdivbox .navbtnac:nth-child(2) .img {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAABDlBMVEUAAAAGtP8Ftf8At/8Avf8Jrv8Gtv8Hs/8Hs/8Gt/8Fu/8Gt/8Bz/8Jq/8IsP8Gt/8KrP8Isv8Gt/8Itf8Dx/8Irv8AwP8GuP8Itv8GvP8Irv8DxP8IsP8Jrv8EvP8Fvv8Fvf8Fu/8Gtv8B0P8BzP8EwP8Jr/8Bz/8KrP8B0P8Kqv8Htf8Fuv8Ir/8Jrf8Jqv8A0f8FvP8Cyv8Fvv8Czv8Jsf8HsP8A0P8Jq/8Itf8Isf8A0P8Gvf8Azf8Dwf8Gs/8A0f8JrP8Gsv8Gr/8Atf8Auf8Fv/8Htf8FwP8Fu/8Euv8Jrv8Gu/8Htv8HtP8Isv8KrP8Dx/8Huf8Gvf8Cy/8Ewv8ExP8Bz/8JsP8Fv//mcjgNAAAAS3RSTlMAIR4WBJclO9iwinv7+/r07uXWzLh2Cu/q5puaXFhJMfr5+O3t7e3m5tPT0L24tKyro5qYl5OKiYmHgnhrW1tQNzcuKxkO+u/SmUOF39OFAAABkUlEQVQ4y4XR51bCQBAF4OumkYQmCkq3994LvdgoKqDI+7+IlCWZTQh8/2buzeScBKLS88Xhtt+/fXjxXIIndr/fJ/bvGWaRbvx9B/+NBJf8Tm+GnTxE8lXPw5UMIrb67Wk1Ru7Rnrtp30z+zpUEV/hZoMC/y+6AeElm1GzubUDtShi57hLxLMaMLnWNIbZBNptZcJe0uMEAGE3i3f5Rm3RvAIjTRQaWE7qPA1qTqsByKQQaTGH+oBcpE3qHMjBVDwmBjogwh5bAGR1BBGstQYRhLNcSrWHLuTFVuZ7RW068uFAb623R+vHK0LFz/YoIHUOPKjj1MUQTH3Q6qSBUH4l0mJ+W5RoEtWU7M6HZQxEORTvTAOsxH1x81ssA3E2HW7jcTrM7ACz4NxGFS5RHQYYhhU9PcHnikYIRaa8xFlTSWlVd4qoVLZUITpI9CWOpxgIpcIn5vQSm5NN5vVMZltiZd+8sBkJWvjwoMkTp8KxaOA0XSQk4awFFwizs4YDWDh4YPJWj50fhQCB8dB4tQ/APRlktiCsnLZAAAAAASUVORK5CYII=)
}

.hyplan .botdivbox .navbtnac:nth-child(3) .img {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAABC1BMVEUAAAAAtv8Avf8ItP8Isv8Ft/8Hsf8GvP8Isf8Guv8Gtv8GuP8Gtf8Bz/8Jq/8Isf8KrP8FvP8Guf8DyP8Krf8Irv8Fuv8AuP8AzP8Htv8Htf8Itf8HtP8Gu/8Hsf8IsP8BzP8EwP8Jr/8Bz/8Gu/8KrP8Isv8B0f8Kqv8Irv8Jrf8Htf8A0P8Kq/8Irv8Cyv8DxP8Fvv8Ir/8Czv8Ht/8Az/8GvP8Is/8A0P8Iq/8Fu/8Bx/8ByP8Jrv8Htv8A0f8Azf8Au/8AtP8B0P8Fvv8B0P8Guf8Isv8Fu/8FuP8FvP8GvP8Auv8Jrf8JsP8Guv8Ht/8Isv8ItP8Fvv8Ew/8Dx/8GvP8Cy/8Bz/9/vvfRAAAATXRSTlMAFgRE3Toe+uiviO9b+/v37uvXuJeKUhkK/Pjq1no3+u3t7ebm5uHW1ri0sK+vm5qamJiXlIqKe3h4Y1taV0k3Hh4J7+7r0Mm/jYxXJZ9rMG0AAAGQSURBVDjLjc9nW8IwFIbhJ9EWhYKAgKiAe++9914gqOj//yWmXKUklVLvLzkneXOdBIO8OFxduEkm7xZWDy8kYS73Zn40M3uXdCN2kj8ByR3BH6eT311MnmCSG98hNiSa4vBXqOEiPqlyPZKSts3Pnjb9f3xG8H4kpj4iTAlcWx+RtlCuYk1PAax2czsChWZb7ArY99uMgGevPgaRafr2gdmabxCus63qERisdcyCVdM47nC1xl7hpaazKOttRr3sSa1lGMkYwbI3wBx+L73B+kH23XDsDq+A827KkjA3Ejacq8Fq29xnVOt24/F4Ade5qnb14ChjWmejE2ZwvNHh9LkAy10LDU2CUiNgDNTtoBIr/wuucFDvCLyxrjnA+l/QQg50uvl+pQQ8uMW8lhuQkK+bhgB12ZQH7ImqoRWsmiZslO3o4DYuMR0VnBa0ONUIDp71t57WaZNLvXJLEl9xOTy3XEQjc2G5nMR0lu4WS5/xh8ilgrFUTtCNnZ/TY3N5m1CVo7XFdCqVXlw7qmD4BR2sTXOI4ea7AAAAAElFTkSuQmCC)
}

.hyplan .botdivbox .navbtnac:nth-child(4) .img {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAABX1BMVEUAAAAIt/8Gtv8FwP8Gtv8Fvf8Is/8JsP8AuP8Guf8Gu/8Fu/8Isf8Guv8Is/8Hs/8Hsf8Ft/8Isf8Jrv8Isv8Gu/8Guf8GtP8Guf8Hsv8GuP8Isf8Fu/8Fuv8IsP8Bz/8Htv8IsP8Jq/8Jrv8Gt/8GtP8Gtv8Jrv8EwP8Irv8Fuv8FuP8Htf8Hsv8AxP8Bzv8Htf8FvP8Isf8FvP8Fvf8Fvv8Isv8Isv8Hsf8IsP8GtP8Arv8FwP8Gvf8Kq/8EwP8Bz/8Isf8KrP8B0P8Kqv8DyP8Dxv8Irv8Htf8Jqv8A0f8IsP8Cyv8DxP8Irv8Fvv8Czv8Gu/8Iq/8A0P8Azf8DxP8JrP8A0f8Kr/8Axf8Auf8AzP8As/8B0P8GuP8Htf8IsP8Ht/8Ir/8A0P8Az/8IsP8Evv8Aov8Jrf8IsP8Is/8Htv8Guv8Dx/8Cy/8HuP8GvP8Ewv8ExP8Bz/8Fv/+DCV4SAAAAaHRSTlMAZsyq1ZDDqgTErMqvpaWOaUzLl5CIhzrqvrGhcGke+/v7++3W0ci0s4lfRD42Hu3h0snEwLB+dm9bKxb7+u/t5ubm09O4uLivrKulmpqamJd7eXhbWlc3MxYWCgrv7+/euZ2JiWE7FpbVhnEAAAIaSURBVDjLhc95U9pAHMbxR5tiECoCaoC2oNz3JVAQ71vrfV+9z5Bobcv7Hze7WROE4Oef/c08XyYDOp0fb68UQqEPK9vH57CU/7b432Txe75ndnkQ4gkXOrjs7k4Kdz0UTp5k4s6dhR3R3F2v3VpauzY6cf22j3UR3O6/vnZ5d/r3Gaesu1poa2arL5hku53k5yydFq5ouN+mhsGVHOCSbNsHkZ+7p17B/VLzE9MVZOnpxjDb5vIAxu95yK63cEzjDT3HacguwKcyJFSrmYrKQrWSqaok1EcfIKmP4YSaQVoL7SRMw61O0JCScGgO7ekSD0tphzk8ROCPjoT0ZSE9ScjXAKJGmBvQzMDuxww9c0YYhU/RBcBFBXBf+PoRkwo3aB8k4raYogjk1G5y6iZNYSxOV7ugKEWBKCo+wQj7fNqtjCHA108QWroRSPqf8dtY2HJhhK8CNo3QRd9R2OLd4SZq5tA2IGihBxCBYD0LJ19rkMxhFg0W1slDGKEELJlCZ8bPwnet8mtNUR+XAKRk5j1c9GWh3CkFIDjFQ/eYRoKtTMLahVMevfCzbSoIwitTQ+A8MdTlH/gqZ5FgmxeaZoT9yjnEkNHpkctDn2W/k30t0gTVkJ/RgG7vd1974MSNft2GiEc3CesucQMT0WvVeUV0Oov0yiJn6NL0hp9mYe8v9BJMLZuz5VQQlnJHW6vz4fD86tZRDh0eAHHQemJGJLbwAAAAAElFTkSuQmCC)
}

.hyplan .botdivbox .navbtnac:nth-child(5) .img {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAABMlBMVEUAAAAKrP8Gt/8Auv8Htf8Jrv8GtP8Ar/8Auf8Avf8Gu/8Isv8Gtf8Arv8Jq/8KrP8GuP8Guv8Hs/8Dx/8Irv8CzP8EwP8GvP8IsP8Gs/8Av/8Bz/8Fuv8EwP8Isf8Isv8Hs/8HtP8Guv8HsP8HtP8HsP8Hs/8Cxv8Ev/8Irf8Hsv8Euf8Gs/8AyP8Gvf8IsP8Hsf8Gtv8BzP8Jr/8Bz/8KrP8Isf8B0P8Kqv8Fu/8Fuv8Gt/8Jqv8A0f8Htf8FvP8GvP8A0P8Jq/8Gvf8Gu/8Iq/8A0P8Gs/8A0f8JrP8Atf8Awv8B0P8Guf8Gt/8B0P8B0P8Gvf8Htv8Gt/8FvP8Hsf8Huf8Etv8Jrf8Gu/8Isv8Ht/8Jr/8Ew/8Gvf8JsP8Itf8Dx/8Cy/8Fv/8Bz/8Huf9IwGyVAAAAWHRSTlMA/n8J+5ceBhkE5YA6Ffvu7NjWuLaZmX9ELBb67+znzL+xr5qQiXpdW1pVPygg+vry7u3t5ubf09PBurOsq6mbiomJhXt5eE43NxgO/PTx7+vT0cmdk24/GpFdMAAAAcBJREFUOMuFzQdv2kAYxvGneMWOzQrQsneABLL3aLNn98ZuGmfw/b9CLl74Tj74SZZOz/uXDNrVxeH2l4/Fr9uHF1fgGhxvPIdsHA8QpZAtPjOK2QLA6qw9RljrgKZkHzmyCkKEuQeuOQEBhe7YUoEvdzdRDp7u3RRdOArlpynKBffH/xnaaZlZciDkJWb9NoNTZlqSARwNabu3wNsh8XN3PB4B0OiuIcANU1D2glUDdLr7ADihViLP21Sw6zjzn4szr+CGJWGgDX9jceRfz9AYeRASG8VI9OkGe/61gZTloULL+oN9K4aOf00hyQn30bV+oO9fSxA5YRJ58in+VeSGqyT8DHUcJm0PFdp2DQv2d8j+dRVpTniJ93aLxJ406tFhE3lR7JPYU8e86Zl/R+hwzK6oRtpsoS8GV+gm5ZcbmtUts6agFuw6UKHLuuCEplkV0ArWCoC2SaveuGHlUhqPbQDy8j1tK49ZZlqWQUj3jJV2mlkkvDLW/02xbsDRmxb24Gn+nagJn5qZ1GVUBITMhE5AiCrxOkkFbSHxJkKiB7AMKc5mcclAFPlkM5xtnsjguj4/2EnE44mdg/NrUF4AjClXTzBvsCUAAAAASUVORK5CYII=)
}

.hyplan .yxdivbox {
  float: left;
  width: 8.4rem;
  margin-left: .4rem;
  height: .93333rem;
  margin-top: .26667rem
}

.hyplan .yxdivbox span {
  float: left;
  width: 1.73333rem;
  height: .93333rem;
  box-sizing: border-box;
  padding-right: .16rem
}

.hyplan .yxdivbox .selediv {
  float: left;
  width: 6.66667rem;
  height: .93333rem;
  background: #f5f6fe;
  border: .02667rem solid #c0c2dd;
  border-radius: .13333rem;
  padding-left: .29333rem;
  position: relative;
  font-weight: 500;
  color: #30333e;
  font-size: .34667rem;
  outline: none
}

.hyplan .yxdivbox .selediv img {
  width: .24rem;
  height: .13333rem;
  position: absolute;
  right: .29333rem;
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg)
}

.hyplan .yxdivbox font {
  margin: 0 .24rem;
  font-weight: 500;
  color: #30333e
}

.hyplan .yxdivbox .tiemselediv {
  width: 2.93333rem;
  float: none
}

.hyplan .yxdivboxasd {
  float: left;
  width: 8.4rem;
  margin-left: .4rem;
  height: .93333rem;
  margin-top: .4rem;
  margin-bottom: .4rem
}

.hyplan .yxdivboxasd div {
  width: 2.53333rem;
  height: .93333rem;
  background: #fff;
  border: .02667rem solid #68a6f7;
  border-radius: .13333rem;
  font-weight: 700;
  color: #68a6f7
}

.hyplan .yxdivboxasd div:nth-child(2) {
  background: -webkit-linear-gradient(left, #2c66ee, #85ccf5);
  background: linear-gradient(90deg, #2c66ee, #85ccf5);
  color: #fff;
  border-color: transparent;
  margin-left: .26667rem
}

.hyplan .tablebox {
  float: left;
  width: 8.8rem;
  overflow-x: scroll;
  background: #fff;
  margin-left: .4rem
}

.hyplan .tablebox .tableboxinner {
  float: left;
  width: 100% !important;
  position: relative
}

.hyplan .tablebox .tableboxinner .ltfixedbox {
  float: left;
  width: 1.86667rem;
  position: absolute
}

.hyplan .tablebox .tableboxinner .ltfixedbox .lineboxdiv {
  width: 1.97333rem
}

.hyplan .tablebox .tableboxinner .ltfixedbox .lineboxdiv div {
  width: 1.86667rem
}

.hyplan .tablebox .tableboxinner .rtfixedbox {
  float: left;
  width: 6.93333rem;
  overflow-x: auto;
  margin-left: 1.81333rem
}

.hyplan .tablebox .tableboxinner .rtfixedbox .rtfixedboxinner {
  float: left;
  width: 24.64rem
}

.hyplan .tablebox .tableboxinner .lineboxdiv {
  float: left;
  width: 100%;
  background: #f5f5fd;
  border-radius: .13333rem;
  height: .93333rem
}

.hyplan .tablebox .tableboxinner .lineboxdiv > div {
  float: left;
  width: 3.52rem;
  height: .93333rem;
  font-weight: 700;
  color: #7e88ad;
  font-size: .32rem
}

.hyplan .tablebox .tableboxinner .lineboxdiv > div .img {
  width: .18667rem;
  height: .32rem;
  display: inline-block;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAMAAAD9GTxlAAAAdVBMVEUAAABmo/XBwt5npvjAwt7Awd3Awt3Awd1opvdopvdnpvbAwd3Awt7Cwt5npvhmpfe6xNhgn/+lvvJVleu/v9Vopvhopvdopvhopve/wt1npvfAwd2/wt3Bw95opvdnpfdopve/wt7AwNxnqvlmofdopvfAwt3oQuuNAAAAJXRSTlMAGOX57eTTz8q/pZWKbFo/GhANBgbu5NfTvLq6p6Gbg3tUUSoeCJE9rAAAAHNJREFUGNOtzMcBgzAUBNG1ySYH52yz6r9EkMQXKoB3m8vAGM9pC6e9kFkv1d84O0i+aLxtfbiodFUUQQ3UAZ3jHyd6UmQU9r7zYEt5tHeiHKHyhPj6+QPKtUrMCqkCxsPWE9Zw1XUfsOgSpZIOThPHDbQJynoUpsrXAqYAAAAASUVORK5CYII=) no-repeat;
  background-size: 100% 100%;
  margin-left: .18667rem;
  margin-top: .02667rem
}

.hyplan .tablebox .tableboxinner .lineboxdiv > div .imgsd {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAYCAMAAAD9GTxlAAAAaVBMVEUAAADBwt5mo/XAwd2Mq+BnpvjAwt1opvdopvfAwt1npvfAw93Awt7Cwt5npvi/wd26xNhhp//ExOtopvhopvdopfdopvdnpvdopfa/wt3Bwt5npfdopvdnpPdmpvdnqvlmofdopvfAwt1ku5v/AAAAIXRSTlMA5RjRBvnsyr+7n5SKbFpRGg4N7uTY07qnp6CDe0M8Kh69V/OOAAAAa0lEQVQY063HVwLCIBBAwaeQ3mPvZu9/SAUE9wCZv8EbjRlJZiNi5jhbyVdlCS7iXcNa+WndOkk6GEQZyHVzmo3SsKatAuWinNnrFjyz/3Yv6NOyB8A9tserw24E9uRWE03HZSktyftQTDgfau0SMwLSmJkAAAAASUVORK5CYII=) no-repeat;
  background-size: 100% 100%
}

.hyplan .tablebox .tableboxinner .lineboxdiv > div .imgnone {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAYCAMAAAAS21dbAAAAUVBMVEUAAACenr+ZnbKYnbKZnbKZnbKYnbCSoKiZnbKYnLGZnbKanbKZnbKZnbKZnrKZnbKZnbKZnrKZnLKZnbGZnbOYnLKYm7GZnrCTnbGVlaqZnbKg/skeAAAAGnRSTlMAB/NG59FeC8q6tqSfl3vxr62OinV0XDcaGF3Mfb4AAABpSURBVBjTrc9JFoUgEEPRoCL2v7HP/hcqp+RA4dg7e7ME4rD2ROIs2biYpqXXxR4oxpATg0myZlT7LIvURQlUVCrgq/uH9xnFZ0eleez5GOzZ3vzAlh9ccVsoZiD40+uR9GRr9KZxcBAXIZ0OxUixZc0AAAAASUVORK5CYII=) no-repeat;
  background-size: 100% 100%
}

.hyplan .tablebox .tableboxinner .lineboxtext {
  background: #fff;
  height: 1.06667rem;
  border-bottom: .02667rem solid rgba(205, 209, 223, .6);
  border-radius: 0
}

.hyplan .tablebox .tableboxinner .lineboxtext div {
  font-weight: 500;
  height: 1.04rem;
  color: #30333e
}

.hyplan .tablebox .nonedat {
  float: left;
  width: 6.26667rem;
  height: 2.24rem;
  margin: 1.09333rem 0 1.2rem 1.2rem
}

.hyplan .nonemoretex {
  float: left;
  width: 8.4rem;
  height: 1.30667rem;
  color: #fff;
  font-size: .32rem;
  font-weight: 500;
  color: #7e88ad
}

.hyplan .topnoboard {
  float: left;
  width: 9.2rem;
  background: #fff;
  border-radius: .13333rem;
  margin-top: .26667rem;
  padding-top: .13333rem
}

.meberdiv .toppartdiv .detailbox .detdiv > div, .textcenter {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center
}

.meberdiv .listbox > div, .meberdiv .ltdivcont, .meberdiv .toppartdiv .detailbox .detdiv > div, .textcenter, .textleft {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.meberdiv .listbox > div, .meberdiv .ltdivcont, .textleft {
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start
}

.meberdiv {
  float: left;
  width: 100%
}

.meberdiv div {
  box-sizing: border-box
}

.meberdiv .ltdivcont {
  float: left;
  width: 100%;
  height: .53333rem;
  margin-top: .61333rem;
  font-size: .50667rem;
  font-weight: 500;
  color: #30333e
}

.meberdiv .ltdivcont div {
  width: .13333rem;
  height: .53333rem;
  background-image: -webkit-linear-gradient(bottom, #0aabff, #06beff 75%, #01d1ff), -webkit-linear-gradient(#000, #000);
  background-image: linear-gradient(0deg, #0aabff, #06beff 75%, #01d1ff), linear-gradient(#000, #000);
  float: left;
  margin: 0 .29333rem 0 .4rem;
  border-radius: .05333rem
}

.meberdiv .listbox {
  float: left;
  width: 50%;
  height: 2rem;
  border-bottom: .02667rem solid rgba(205, 209, 223, .6)
}

.meberdiv .listbox > div {
  float: left;
  width: 100%;
  height: .37333rem;
  padding-left: .4rem;
  font-size: .34667rem;
  font-weight: 500;
  margin-top: .45333rem;
  color: #6d7683
}

.meberdiv .listbox > div img {
  float: left;
  width: .37333rem;
  height: .37333rem;
  margin-right: .2rem
}

.meberdiv .listbox > div:nth-child(2) {
  height: .45333rem;
  font-size: .45333rem;
  color: #30333e;
  margin-top: .26667rem
}

.meberdiv .listbox:nth-child(2) div:nth-child(2) {
  color: #30333e
}

.meberdiv .toppartdiv {
  float: left;
  width: 100%;
  height: 6.21333rem;
  background: #fff;
  border-bottom: .26667rem solid #f2f2f2
}

.meberdiv .toppartdiv .topboarddiv {
  float: left;
  width: 9.2rem;
  height: 2rem;
  background-color: #fff;
  box-shadow: 0 0 .26667rem 0 rgba(127, 143, 211, .3);
  border-radius: .21333rem;
  margin: .4rem 0 0 .4rem
}

.meberdiv .toppartdiv .detailbox {
  float: left;
  width: 100%;
  height: .69333rem;
  margin-top: .8rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex
}

.meberdiv .toppartdiv .detailbox .detdiv {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: .69333rem
}

.meberdiv .toppartdiv .detailbox .detdiv > div {
  width: 100%;
  height: .32rem;
  font-weight: 500;
  color: #6d7683;
  font-size: .32rem
}

.meberdiv .toppartdiv .detailbox .detdiv > div .img {
  float: left;
  width: .37333rem;
  height: .37333rem;
  margin-right: .10667rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAY1BMVEUAAACZnbKZnbKZnLKZnbKZnbKYnLKXnbKZnbKYnbOZnbKYnLKZnbKZnbKYnLKZnbKYnLKYnLObnLOWnLCYnbKZnbGanLKamrGLoq6ZnbOZnrOZnbKYnbKZnLKbm62UlK6ZnbLcFo/PAAAAIHRSTlMA6fLZ+MNhSD0li4f6ysnITUEyK7ecWjcLu5ZwbWQcEx2OJoQAAADOSURBVCjPhZPpEoIwDIS3lGIvDkHB277/U+qoNAkOw/5i55uGdJMiywajYlQmWCxV6ZSlK4Fcm4RaR2xXpIWKXWZl+lP5o47O6ak389lv5TpldcAwf9efPhNpBLpsKgCaQXW9KfoHYNOqLDy/wFlz6GHIHJ/AgUEDxWAAOt4BRAAn7JmLAhbAyFOCYq4BgihrmLssGhJXuUMU8iKEHg8ZAvRas1oGjzeMFLwc2QBMgUYmh932Qyhp2BtrsrVggGska9z2UpOsN6qMynh6Di9Xf0I2UifZKAAAAABJRU5ErkJggg==) no-repeat;
  background-size: 100% 100%;
  position: relative
}

.meberdiv .toppartdiv .detailbox .detdiv > div .img:hover .tipsbox {
  display: block
}

.meberdiv .toppartdiv .detailbox .detdiv > div .img .tipsbox {
  float: left;
  width: 5.84rem;
  height: .64rem;
  background: #545974;
  font-weight: 500;
  color: #fff;
  text-align: center;
  line-height: .64rem;
  border-radius: .08rem;
  font-size: .26667rem;
  position: absolute;
  left: -.18667rem;
  display: none;
  top: -.8rem
}

.meberdiv .toppartdiv .detailbox .detdiv > div .img .tipsbox font {
  width: 0;
  height: 0;
  float: left;
  border: .16rem solid transparent;
  position: absolute;
  left: .18667rem;
  bottom: -.29333rem;
  border-top-color: #545974
}

.meberdiv .toppartdiv .detailbox .detdiv > div:nth-child(2) {
  height: .37333rem;
  font-size: .37333rem;
  margin-top: .26667rem;
  font-weight: 500;
  color: #30333e
}

.meberdiv .botboraddiv {
  float: left;
  width: 100%
}

.meberdiv .botboraddiv .ltdivcont {
  margin-bottom: .26667rem
}

.meberdiv .botboraddiv .listbox {
  width: 50%;
  float: left;
  height: 2.13333rem
}

.meberdiv .botboraddiv .listbox div {
  padding-left: 0
}

.meberdiv .botboraddiv .listbox div:nth-child(2) {
  color: #30333e !important
}

.meberdiv .botboraddiv .listbox div .img {
  width: .37333rem;
  height: .37333rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAY1BMVEUAAACZnbKZnbKZnLKZnbKZnbKYnLKXnbKZnbKYnbOZnbKYnLKZnbKZnbKYnLKZnbKYnLKYnLObnLOWnLCYnbKZnbGanLKamrGLoq6ZnbOZnrOZnbKYnbKZnLKbm62UlK6ZnbLcFo/PAAAAIHRSTlMA6fLZ+MNhSD0li4f6ysnITUEyK7ecWjcLu5ZwbWQcEx2OJoQAAADOSURBVCjPhZPpEoIwDIS3lGIvDkHB277/U+qoNAkOw/5i55uGdJMiywajYlQmWCxV6ZSlK4Fcm4RaR2xXpIWKXWZl+lP5o47O6ak389lv5TpldcAwf9efPhNpBLpsKgCaQXW9KfoHYNOqLDy/wFlz6GHIHJ/AgUEDxWAAOt4BRAAn7JmLAhbAyFOCYq4BgihrmLssGhJXuUMU8iKEHg8ZAvRas1oGjzeMFLwc2QBMgUYmh932Qyhp2BtrsrVggGska9z2UpOsN6qMynh6Di9Xf0I2UifZKAAAAABJRU5ErkJggg==) no-repeat;
  background-size: 100% 100%;
  position: relative;
  margin-left: .17333rem
}

.meberdiv .botboraddiv .listbox div .img:hover .tipsbox {
  display: block
}

.meberdiv .botboraddiv .listbox div .img .tipsbox {
  float: left;
  width: 3.2rem;
  height: .64rem;
  background: #545974;
  font-weight: 500;
  color: #fff !important;
  text-align: center;
  line-height: .64rem;
  border-radius: .08rem;
  font-size: .26667rem;
  position: absolute;
  left: -.18667rem;
  display: none;
  top: -.8rem
}

.meberdiv .botboraddiv .listbox div .img .tipsbox font {
  width: 0;
  height: 0;
  float: left;
  border: .16rem solid transparent;
  position: absolute;
  left: .21333rem;
  bottom: -.29333rem;
  border-top-color: #545974
}

.meberdiv .listcontentboxddd {
  float: left;
  width: 100%;
  padding: 0 .4rem
}

#xiajixq .collebox .showdetbox .showdetdiv div, .textcenter {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

#xiajixq .collebox .lvtitle, #xiajixq .contentbox .contentboxinner .detailinfo .ltdivdt .bigdivlines, #xiajixq .contentbox .contentboxinner .detailinfo .ltdivdt .linedivs, #xiajixq .contentbox .contentboxinner .divtwopdiv > div, .textleft {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

#xiajixq {
  float: left;
  width: 100%;
  height: 100%;
  background: #f2f2f2
}

#xiajixq .tablebox .rtfixedboxinner {
  width: 21.38667rem !important
}

#xiajixq .contentbox .contentboxinner {
  padding: .4rem .4rem .4rem
}

#xiajixq .contentbox .contentboxinner .detailinfo {
  float: left;
  width: 100%;
  border-bottom: .02667rem solid rgba(205, 209, 223, .6);
  margin-bottom: .34667rem
}

#xiajixq .contentbox .contentboxinner .detailinfo .ltdivdt {
  float: left;
  width: 7.06667rem;
  height: 4.30667rem;
  padding-top: .24rem
}

#xiajixq .contentbox .contentboxinner .detailinfo .ltdivdt .linedivs {
  float: left;
  width: 100%;
  height: .32rem;
  margin-top: .21333rem;
  font-size: .32rem;
  font-weight: 500;
  color: #6d7683
}

#xiajixq .contentbox .contentboxinner .detailinfo .ltdivdt .linedivs font {
  color: #30333e
}

#xiajixq .contentbox .contentboxinner .detailinfo .ltdivdt .bigdivlines {
  float: left;
  width: 100%;
  height: .45333rem;
  font-size: .45333rem;
  font-weight: 500;
  color: #30333e;
  margin-top: .26667rem;
  margin-bottom: .34667rem
}

#xiajixq .contentbox .contentboxinner .detailinfo .ltdivdt .bigdivlines img {
  width: .37333rem;
  height: .37333rem;
  margin-left: .28rem
}

#xiajixq .contentbox .contentboxinner .detailinfo .rtdivdt {
  float: left;
  width: 1.33333rem
}

#xiajixq .contentbox .contentboxinner .detailinfo .rtdivdt img {
  float: left;
  width: 1.33333rem;
  height: 1.33333rem;
  margin-top: .26667rem
}

#xiajixq .contentbox .contentboxinner .divtwopdiv {
  float: left;
  width: 100%
}

#xiajixq .contentbox .contentboxinner .divtwopdiv > div {
  float: left;
  width: 50%;
  height: .74667rem;
  font-size: .32rem;
  font-weight: 500;
  color: #6d7683
}

#xiajixq .contentbox .contentboxinner .divtwopdiv > div font {
  color: #30333e;
  font-weight: 700
}

#xiajixq .contentbox .contentboxinner .divtwopdiv:last-child {
  margin-bottom: .34667rem
}

#xiajixq .collebox {
  float: left;
  width: 100%;
  background: #fff;
  border-radius: .13333rem;
  padding: 0 .4rem
}

#xiajixq .collebox .lvtitle {
  float: left;
  width: 100%;
  height: 1.33333rem;
  border-bottom: .02667rem solid rgba(205, 209, 223, .6);
  font-weight: 700;
  color: #30333e;
  font-size: .37333rem;
  position: relative
}

#xiajixq .collebox .lvtitle img {
  width: .37333rem;
  height: .21333rem;
  position: absolute;
  -webkit-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: all .15s linear;
  transition: all .15s linear;
  right: 0
}

#xiajixq .collebox .showdetbox {
  float: left;
  width: 100%;
  height: 2rem;
  border-bottom: .02667rem solid rgba(205, 209, 223, .6);
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex
}

#xiajixq .collebox .showdetbox .showdetdiv {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1
}

#xiajixq .collebox .showdetbox .showdetdiv div {
  width: 100%;
  height: .32rem;
  font-size: .32rem;
  font-weight: 500;
  color: #6d7683;
  margin-top: .50667rem
}

#xiajixq .collebox .showdetbox .showdetdiv div:nth-child(2) {
  font-weight: 500;
  color: #30333e;
  height: .45333rem;
  margin-top: .32rem;
  font-size: .45333rem
}

#xiajixq .collebox:nth-child(2) {
  padding: 0
}

#xiajixq .collebox:nth-child(2) .lvtitle {
  width: 8.4rem;
  margin-left: .4rem
}

#xiajixq .colleboxac {
  height: 1.30667rem;
  overflow: hidden
}

#xiajixq .colleboxac .tablebox .tableboxinner .lineboxdiv div:first-child {
  display: none !important
}

#xiajixq .colleboxac .lvtitle img {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg)
}

.popover-content {
  padding: .05333rem .10667rem;
  font-size: .32rem
}

.popover-content span {
  margin: 0 .10667rem
}


#defitscont .collebox .lvtitle, .textleft {
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start
}

#defitscont, .memberpop {
  width: 100%;
  height: 100%
}


#defitscont .contentbox .contentboxinner {
  padding: .2rem .4rem;
  height: 100%;
}

#defitscont .contentbox .contentboxinner .rtfixedboxinner {
  width: 21.33333rem !important
}


#defitscont .collebox .lvtitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 .27rem;
  width: 100%;
  height: 1.33rem;
  background: rgba(255, 255, 255, 0.10);
  border: .03rem solid rgba(255, 255, 255, 0.10);
  font-size: .37rem;
  position: relative;
  border-radius: .19rem;
}

#defitscont .collebox .lvtitle .ngblue {
  width: .32rem;
  height: .32xrem;
  position: absolute;
  right: .32rem;
  transition: all .15s linear;
  transform: rotate(0deg)
}

#defitscont .collebox .lvtitle div {
  display: flex;
  flex-direction: row
}

#defitscont .collebox .lvtitle div img {
  width: .10667rem;
  height: .42667rem;
  display: block;
  margin-top: .05333rem;
  margin-right: .2rem
}

#defitscont .collebox .showdetbox {
  width: 100%;
  background: rgba(255, 255, 255, 0.10);
  border: .03rem solid rgba(255, 255, 255, 0.10);
  border-radius: .19rem;
  margin-top: .27rem;
}

#defitscont .collebox .showdetbox .showdetdiv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: .03rem solid rgba(255, 255, 255, 0.10);
  height: 1.23rem;
}

#defitscont .colleboxac {
  height: 1.30667rem;
  overflow: hidden
}

#defitscont .colleboxac .lvtitle > img {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg)
}

.finace .ltnavbtn, .textleft {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.finace {
  float: left;
  width: 100%;
  background: #f2f2f2
}

.finace .ltnavbtn {
  float: left;
  width: 100%;
  height: 1.6rem;
  border-bottom: .02667rem solid rgba(205, 209, 223, .6);
  font-weight: 700;
  color: #30333e;
  font-size: .37333rem;
  position: relative;
  background: #fff
}

.finace .ltnavbtn .yxico {
  width: .45333rem;
  height: .45333rem;
  margin: 0 .4rem
}

.finace .ltnavbtn .arrow {
  width: .21333rem;
  height: .37333rem;
  position: absolute;
  right: .4rem
}

.finacegame {
  float: left;
  background: #f2f2f2
}

.finacegame .contentbox .contentboxinner {
  padding: .13333rem .4rem .4rem
}

.finacegame .contentbox .contentboxinner .tableboxinner {
  width: 28.5rem
}

#finaceyhhl {
  float: left;
  background: #f2f2f2
}

#finaceyhhl .contentbox .contentboxinner {
  padding: .13333rem .4rem .4rem
}

#finaceyhhl .rtfixedboxinner {
  width: 10.82667rem
}

.textcenter, .yjbaobiao .contentbox .contentboxinner .topnoboard .yxdivbox .chaxunbtn, .yjbaobiao .contentbox .contentboxinner .topnoboard .yxdivbox .selediv {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.textleft, .yjbaobiao .contentbox .contentboxinner .topnoboard .detlinebx div:nth-child(2), .yjbaobiao .contentbox .contentboxinner .topnoboard .detlinebx div:nth-child(3) {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.textright, .yjbaobiao .contentbox .contentboxinner .topnoboard .detlinebx {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.yjbaobiao {
  float: left;
  width: 100%;
  background: #f2f2f2
}

.yjbaobiao .contentbox .contentboxinner {
  padding: .13333rem .4rem .4rem
}

.yjbaobiao .contentbox .contentboxinner .topnoboard .yxdivbox {
  margin: .4rem
}

.yjbaobiao .contentbox .contentboxinner .topnoboard .yxdivbox .selediv {
  width: 5.6rem
}

.yjbaobiao .contentbox .contentboxinner .topnoboard .yxdivbox .chaxunbtn {
  float: left;
  width: 2.53333rem;
  height: .93333rem;
  background: -webkit-linear-gradient(left, #01d1ff, #0aabff);
  background: linear-gradient(90deg, #01d1ff, #0aabff);
  border-radius: .13333rem;
  font-weight: 700;
  color: #fff;
  font-size: .37333rem;
  margin-left: .26667rem
}

.yjbaobiao .contentbox .contentboxinner .topnoboard .detlinebx {
  float: left;
  width: 8.4rem;
  height: 1.06667rem;
  border-bottom: .02667rem solid rgba(205, 209, 223, .6);
  margin-left: .4rem
}

.yjbaobiao .contentbox .contentboxinner .topnoboard .detlinebx:last-child {
  border-bottom: none
}

.yjbaobiao .contentbox .contentboxinner .topnoboard .detlinebx .font {
  width: .37333rem;
  height: .37333rem;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAY1BMVEUAAACZnbKZnbKZnLKZnbKZnbKYnLKXnbKZnbKYnbOZnbKYnLKZnbKZnbKYnLKZnbKYnLKYnLObnLOWnLCYnbKZnbGanLKamrGLoq6ZnbOZnrOZnbKYnbKZnLKbm62UlK6ZnbLcFo/PAAAAIHRSTlMA6fLZ+MNhSD0li4f6ysnITUEyK7ecWjcLu5ZwbWQcEx2OJoQAAADOSURBVCjPhZPpEoIwDIS3lGIvDkHB277/U+qoNAkOw/5i55uGdJMiywajYlQmWCxV6ZSlK4Fcm4RaR2xXpIWKXWZl+lP5o47O6ak389lv5TpldcAwf9efPhNpBLpsKgCaQXW9KfoHYNOqLDy/wFlz6GHIHJ/AgUEDxWAAOt4BRAAn7JmLAhbAyFOCYq4BgihrmLssGhJXuUMU8iKEHg8ZAvRas1oGjzeMFLwc2QBMgUYmh932Qyhp2BtrsrVggGska9z2UpOsN6qMynh6Di9Xf0I2UifZKAAAAABJRU5ErkJggg==) no-repeat;
  background-size: 100% 100%;
  margin-right: .4rem;
  position: relative
}

.yjbaobiao .contentbox .contentboxinner .topnoboard .detlinebx .font:hover .tipsbox {
  display: block
}

.yjbaobiao .contentbox .contentboxinner .topnoboard .detlinebx .font .tipsbox {
  float: left;
  width: 7.46667rem;
  height: .64rem;
  background: #545974;
  font-weight: 500;
  color: #fff;
  text-align: center;
  line-height: .64rem;
  border-radius: .08rem;
  font-size: .26667rem;
  position: absolute;
  left: -.18667rem;
  display: none;
  top: -.8rem
}

.yjbaobiao .contentbox .contentboxinner .topnoboard .detlinebx .font .tipsbox font {
  width: 0;
  height: 0;
  float: left;
  border: .16rem solid transparent;
  position: absolute;
  left: .18667rem;
  bottom: -.29333rem;
  border-top-color: #545974
}

.yjbaobiao .contentbox .contentboxinner .topnoboard .detlinebx .fontss {
  width: 0;
  height: 0
}

.yjbaobiao .contentbox .contentboxinner .topnoboard .detlinebx div {
  height: 1.06667rem;
  font-weight: 500;
  color: #30333e;
  font-size: .32rem
}

.yjbaobiao .contentbox .contentboxinner .topnoboard .detlinebx div:nth-child(2) {
  width: 3.14667rem
}

.yjbaobiao .contentbox .contentboxinner .topnoboard .detlinebx div:nth-child(3) {
  width: 4.42667rem;
  position: relative
}

.yjbaobiao .contentbox .contentboxinner .topnoboard .detlinebx div:nth-child(3) font {
  color: #ff685d;
  position: absolute;
  right: .26667rem
}

#finacedcjl {
  float: left;
  background: #f2f2f2
}

#finacedcjl .contentbox .contentboxinner {
  padding: .13333rem .4rem .4rem
}

#finacedcjl .rtfixedboxinner {
  width: 10.82667rem
}

#finacptbaoobiao {
  float: left;
  background: #f2f2f2
}

#finacptbaoobiao .contentbox .contentboxinner {
  padding: .13333rem .4rem .4rem
}

#finacptbaoobiao .rtfixedboxinner {
  width: 10.82667rem
}

#finacptbaoobiao .nonedat {
  background-image: url(data:image/png;base64,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);
  background-size: 100%
}

.title-left[data-v-47135c9a] {
  height: .53333rem;
  padding-left: .21333rem;
  font-size: .42667rem;
  font-weight: 700;
  border-left: .08rem solid #68a6f7
}

.icon-right[data-v-47135c9a] {
  width: .37333rem;
  height: .24rem;
  margin-top: .13333rem
}

.url-content .qrcode-warp[data-v-47135c9a] {
  position: relative
}

.url-content .content-img[data-v-47135c9a] {
  width: 100%;
  height: auto;
  object-fit: contain
}

.url-content .qrcode-img[data-v-47135c9a] {
  width: 2.88rem;
  height: 2.88rem;
  position: absolute;
  left: .48rem;
  bottom: .48rem
}

.url-content .content-link[data-v-47135c9a] {
  height: .96rem;
  line-height: .96rem;
  font-size: .37333rem;
  background-color: #eef0f8;
  border-radius: .10667rem;
  padding: 0 .10667rem;
  margin: .32rem 0
}

.button-groups[data-v-47135c9a] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between
}

.button-groups .button-item[data-v-47135c9a] {
  width: 2.66667rem;
  height: .96rem;
  border-radius: .10667rem
}

#promotion .fzcgtipsbox .botcontent div, #promotion .fzcgtipsbox .fztitle, #promotion .navbtnlines .navbtnline, #promotion .qrpopshow .baocunbtn, .textcenter {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center
}

#promotion .fzcgtipsbox .botcontent div, #promotion .fzcgtipsbox .fztitle, #promotion .navbtnlines .navbtnline, #promotion .qrpopshow .baocunbtn, .textcenter, .textleft {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.textleft {
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start
}

#promotion {
  float: left;
  width: 100%;
  height: 100%;
  background: #f2f2f2
}

#promotion .fzcgtipsbox {
  float: left;
  width: 7.2rem;
  height: 5.2rem;
  background: #fff;
  border-radius: .24rem
}

#promotion .fzcgtipsbox .fztitle {
  float: left;
  width: 100%;
  height: .42667rem;
  font-size: .42667rem;
  font-weight: 700;
  color: #30333e;
  margin-top: .69333rem
}

#promotion .fzcgtipsbox .fztipscontent {
  float: left;
  width: 100%;
  height: 2.85333rem;
  padding: .64rem .74667rem 0 .74667rem;
  font-size: .37333rem;
  font-weight: 500;
  color: #000;
  line-height: .53333rem;
  word-break: break-all
}

#promotion .fzcgtipsbox .botcontent {
  float: left;
  width: 100%;
  height: 1.2rem;
  border-top: .02667rem solid #cdd1df
}

#promotion .fzcgtipsbox .botcontent div {
  float: left;
  width: 50%;
  height: 1.17333rem;
  font-size: .45333rem;
  font-weight: 500;
  color: #000
}

#promotion .fzcgtipsbox .botcontent div:nth-child(2) {
  border-left: .02667rem solid #cdd1df;
  color: #68a6f7
}

#promotion .qrpopshow {
  float: left;
  width: 7.2rem;
  height: 8.26667rem;
  background: #fff;
  border-radius: .24rem
}

#promotion .qrpopshow img {
  float: left;
  width: 4.93333rem;
  height: 4.93333rem;
  margin: 1.06667rem 1.13333rem .66667rem 1.13333rem
}

#promotion .qrpopshow .baocunbtn {
  float: left;
  width: 2.53333rem;
  height: .93333rem;
  background: #fff;
  border: .02667rem solid #68a6f7;
  border-radius: .13333rem;
  margin-left: 2.33333rem;
  font-weight: 700;
  color: #68a6f7;
  font-size: .37333rem
}

#promotion .contentbox {
  height: calc(100% - 2.72rem)
}

#promotion .contentbox .content-item {
  margin-bottom: .32rem
}

#promotion .navbtnlines {
  float: left;
  width: 100%;
  height: 1.33333rem;
  background: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around
}

#promotion .navbtnlines .navbtnline {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 100%;
  color: #6d7683;
  font-weight: 500;
  font-size: .37333rem;
  position: relative
}

#promotion .navbtnlines .navbtnline font {
  float: left;
  width: 1.12rem;
  height: .10667rem;
  position: absolute;
  background: #68a6f7;
  bottom: 0;
  display: none
}

#promotion .navbtnlines .navbtnlineac {
  font-weight: 700;
  color: #30333e
}

#promotion .navbtnlines .navbtnlineac font {
  display: block
}

.textcenter {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

#noticediv .botdetilpop .botnotcont .botnotcontinner .nttitle .dftitle, #noticediv .botdetilpop .botnotcont .botnotcontinner .nttitle .dttiem, #noticediv .botdiv .noticediv .nottime, #noticediv .botdiv .noticediv .nottitle, #noticediv .topbd .divlistdivds div, .textleft {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.textright {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

#noticediv {
  float: left;
  background: #fff;
  height: 100%;
  width: 100%
}

#noticediv .contentbox {
  height: calc(100% - 6.66667rem)
}

#noticediv .botdetilpop {
  float: left;
  width: 100%;
  height: 100%
}

#noticediv .botdetilpop .botnotcont {
  float: left;
  width: 100%;
  height: calc(100% - 1.33333rem);
  overflow-y: auto
}

#noticediv .botdetilpop .botnotcont .botnotcontinner {
  float: left;
  width: 100%;
  padding: .4rem
}

#noticediv .botdetilpop .botnotcont .botnotcontinner .nttitle {
  float: left;
  width: 100%;
  height: 1.44rem;
  border-bottom: .02667rem solid rgba(205, 209, 223, .6);
  margin-top: .48rem
}

#noticediv .botdetilpop .botnotcont .botnotcontinner .nttitle .dftitle {
  float: left;
  width: 100%;
  height: .42667rem;
  font-size: .42667rem;
  font-weight: 700;
  color: #424653
}

#noticediv .botdetilpop .botnotcont .botnotcontinner .nttitle .dttiem {
  float: left;
  width: 100%;
  height: .32rem;
  font-size: .32rem;
  font-weight: 500;
  color: #9ca3bf;
  margin-top: .26667rem
}

#noticediv .botdetilpop .botnotcont .botnotcontinner .maintext {
  float: left;
  width: 100%;
  font-weight: 500;
  color: #424653;
  font-size: .37333rem;
  line-height: .64rem;
  padding-top: .53333rem
}

#noticediv .botdetilpop .botnotcont .botnotcontinner .maintext div {
  float: none
}

#noticediv .topbd {
  float: left;
  width: 100%;
  border-bottom: .26667rem solid #f2f2f2;
  background: #fff
}

#noticediv .topbd .divlistdivds {
  float: left;
  width: 100%;
  border-bottom: .02667rem solid rgba(205, 209, 223, .6) !important;
  height: 1.6rem
}

#noticediv .topbd .divlistdivds:nth-child(3) {
  border-bottom: none
}

#noticediv .topbd .divlistdivds:nth-child(3) div img {
  width: .45333rem;
  height: .46667rem
}

#noticediv .topbd .divlistdivds:nth-child(2) div img {
  width: .4rem;
  height: .36rem
}

#noticediv .topbd .divlistdivds div {
  float: left;
  width: 3.06667rem;
  height: 100%;
  font-weight: 500;
  color: #6d7683;
  font-size: .37333rem
}

#noticediv .topbd .divlistdivds div img {
  width: .41333rem;
  height: .45333rem;
  margin-right: .42667rem;
  margin-left: .4rem
}

#noticediv .topbd .divlistdivds div:nth-child(2) {
  width: 6.93333rem;
  font-weight: 700;
  color: #30333e;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end
}

#noticediv .topbd .divlistdivds div:nth-child(2) img {
  width: .37333rem;
  height: .37333rem;
  margin-right: .4rem
}

#noticediv .botdiv {
  float: left;
  width: 100%
}

#noticediv .botdiv .noticediv {
  float: left;
  width: 100%;
  border-bottom: .02667rem solid rgba(205, 209, 223, .6);
  height: 3.06667rem;
  padding: 0 .26667rem
}

#noticediv .botdiv .noticediv .nottitle {
  float: left;
  width: 100%;
  height: .37333rem;
  font-size: .37333rem;
  font-weight: 700;
  color: #424653;
  margin-top: .53333rem
}

#noticediv .botdiv .noticediv .nottitle font {
  width: .21333rem;
  height: .21333rem;
  background: #e73144;
  border-radius: .10667rem;
  display: inline-block;
  margin-left: .25333rem
}

#noticediv .botdiv .noticediv .nottime {
  float: left;
  width: 100%;
  height: .32rem;
  font-size: .32rem;
  color: #9ca3bf;
  margin-top: .21333rem
}

#noticediv .botdiv .noticediv .nottext {
  float: left;
  width: 9.29333rem;
  height: .92rem;
  font-size: .32rem;
  font-weight: 500;
  color: #424653;
  line-height: .50667rem;
  margin: .4rem 0;
  text-align: left;
  text-overflow: ellipsis
}

#noticediv .botdiv .noticedivrd div {
  color: #9ca3bf !important
}

#tcrecord .contentdiv .contentdivinner .maincontent .conttitle .tptitle, #tcrecord .contentdiv .contentdivinner .maincontent .datalines .bottitle div, #tcrecord .contentdiv .contentdivinner .maincontent .datalines .datatitle div, #tcrecord .headlineds, #tcrecord .toptitle div, .textleft {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

#tcrecord .contentdiv .contentdivinner .maincontent .hasmorebtn, .textcenter {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

#tcrecord .contentdiv .contentdivinner .maincontent .datalines .bottitle div:nth-child(2), #tcrecord .contentdiv .contentdivinner .maincontent .datalines .datatitle div:nth-child(2), .textright {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

#tcrecord {
  position: fixed;
  top: 0;
  z-index: 1000;
  left: 0;
  background: #f5f6fa;
  width: 100%;
  height: 100%
}

#tcrecord .toptitle div {
  position: absolute;
  width: 2.08rem;
  height: 1.17333rem;
  top: 0;
  right: 0;
  font-size: .42667rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #373c4a
}

#tcrecord .headlineds {
  float: left;
  width: 100%;
  height: 1.06667rem;
  color: #373c4a;
  font-weight: 500;
  font-size: .37333rem;
  padding-left: .4rem;
  background: #fff;
  box-shadow: 0 0 .21333rem 0 rgba(130, 143, 190, .3)
}

#tcrecord .headlineds font {
  color: #e81d32;
  margin-left: .26667rem
}

#tcrecord .contentdiv {
  float: left;
  width: 100%;
  height: calc(100% - 2.24rem);
  overflow-x: hidden;
  overflow-y: scroll
}

#tcrecord .contentdiv .contentdivinner {
  float: left;
  width: 100%;
  padding: 0 .4rem .26667rem
}

#tcrecord .contentdiv .contentdivinner .maincontent {
  float: left;
  width: 9.2rem;
  background: #fff;
  border-radius: .26667rem;
  margin-top: .4rem
}

#tcrecord .contentdiv .contentdivinner .maincontent .conttitle {
  float: left;
  width: 100%;
  height: 1.86667rem;
  border-bottom: .02667rem solid #c6c6ca
}

#tcrecord .contentdiv .contentdivinner .maincontent .conttitle .tptitle {
  float: left;
  width: 100%;
  height: .48rem;
  font-size: .48rem;
  font-weight: 700;
  color: #373c4a;
  padding-left: .4rem;
  margin-top: .45333rem
}

#tcrecord .contentdiv .contentdivinner .maincontent .conttitle .bottutle {
  float: left;
  width: 100%;
  height: .32rem;
  font-size: .32rem;
  font-weight: 500;
  color: #6b728d;
  margin-top: .21333rem;
  padding-left: .4rem
}

#tcrecord .contentdiv .contentdivinner .maincontent .datalines {
  float: left;
  width: 8.4rem;
  border-bottom: .02667rem solid #c6c6ca;
  height: 1.6rem;
  margin-left: .4rem
}

#tcrecord .contentdiv .contentdivinner .maincontent .datalines:nth-last-child(2) {
  border: none
}

#tcrecord .contentdiv .contentdivinner .maincontent .datalines .datatitle {
  float: left;
  width: 100%;
  height: .4rem;
  margin-top: .32rem
}

#tcrecord .contentdiv .contentdivinner .maincontent .datalines .datatitle div {
  float: left;
  width: 50%;
  height: .4rem;
  color: #373c4a;
  font-family: DIN;
  font-weight: 500;
  font-size: .37333rem
}

#tcrecord .contentdiv .contentdivinner .maincontent .datalines .datatitle div:nth-child(2) {
  color: #e81d32
}

#tcrecord .contentdiv .contentdivinner .maincontent .datalines .datatitle div font {
  width: .8rem;
  display: inline-block;
  height: .4rem;
  margin-right: .26667rem;
  background: url(data:image/png;base64,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) no-repeat;
  background-size: 100% 100%
}

#tcrecord .contentdiv .contentdivinner .maincontent .datalines .bottitle {
  float: left;
  width: 100%;
  margin-top: .26667rem
}

#tcrecord .contentdiv .contentdivinner .maincontent .datalines .bottitle div {
  float: left;
  width: 50%;
  font-size: .32rem;
  color: #6b728d;
  height: .32rem
}

#tcrecord .contentdiv .contentdivinner .maincontent .hasmorebtn {
  float: left;
  width: 100%;
  height: 1.33333rem;
  border-top: .02667rem solid #c6c6ca;
  color: #f3aa57;
  font-size: .42667rem;
  font-weight: 500
}

.memberreport .contentdiv .contentdivinner .contenbox .btcontentbox .div div, .memberreport .contentdiv .contentdivinner .contenbox .cttitle div, .memberreport .popmaskdiv .linedivboxdd div, .memberreport .popmaskdiv .smtips, .memberreport .timetitle span, .memberreport .toptitle div, .textleft {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.memberreport .popmaskdiv .btndivs .btndiv, .memberreport .timetitle, .textcenter {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center
}

.memberreport .popmaskdiv .btndivs .btndiv, .memberreport .popmaskdiv .linedivboxdd div:nth-child(2), .memberreport .timetitle, .textcenter, .textright {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.memberreport .popmaskdiv .linedivboxdd div:nth-child(2), .textright {
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end
}

.memberreport {
  position: fixed;
  top: 0;
  z-index: 1000;
  left: 0;
  background: #f5f6fa;
  width: 100%;
  height: 100%
}

.memberreport .timetitle {
  float: left;
  width: 100%;
  height: 1.17333rem;
  position: relative;
  font-size: .48rem;
  font-family: PingFang SC;
  font-weight: 700;
  color: #373c4a;
  background: #fff
}

.memberreport .timetitle img {
  width: .32rem;
  height: .53333rem;
  position: absolute;
  left: .50667rem
}

.memberreport .timetitle span {
  width: 2.08rem;
  height: 1.17333rem;
  position: absolute;
  right: 0;
  font-family: PingFang SC;
  font-size: .42667rem;
  color: #373c4a;
  font-weight: 500
}

.memberreport .popmaskdiv {
  width: 100%;
  height: 100%
}

.memberreport .popmaskdiv .smtips {
  float: left;
  width: 100%;
  height: .69333rem;
  font-size: .32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #373c4a;
  padding-left: .4rem;
  background: #fff
}

.memberreport .popmaskdiv .btndivs {
  float: left;
  width: 100%;
  padding-left: .13333rem;
  padding-top: .4rem;
  background: #fff
}

.memberreport .popmaskdiv .btndivs .btndiv {
  float: left;
  width: 2.08rem;
  height: .93333rem;
  background: #fff;
  border: .02667rem solid #d9ddeb;
  border-radius: .13333rem;
  font-size: .37333rem;
  font-weight: 500;
  color: #373c4a;
  margin-left: .26667rem;
  margin-bottom: .26667rem
}

.memberreport .popmaskdiv .btndivs .btndivac {
  background: -webkit-linear-gradient(left, #2c66ee, #85ccf5);
  background: linear-gradient(90deg, #2c66ee, #85ccf5);
  color: #fff;
  border: none
}

.memberreport .popmaskdiv .linedivboxdd {
  float: left;
  width: 100%;
  height: 1.33333rem;
  background: #fff;
  padding: 0 .4rem
}

.memberreport .popmaskdiv .linedivboxdd div {
  float: left;
  width: 30%;
  height: 1.33333rem;
  font-size: .42667rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #373c4a
}

.memberreport .popmaskdiv .linedivboxdd div:nth-child(2) {
  width: 70%
}

.memberreport .popmaskdiv .linedivboxdd div:nth-child(2) img {
  width: .16rem;
  height: .26667rem;
  margin-left: .34667rem
}

.memberreport .popmaskdiv .spdivline {
  border-bottom: .02667rem solid #c6c6ca;
  margin-bottom: 0
}

.memberreport .toptitle div {
  position: absolute;
  width: 2.08rem;
  height: 1.17333rem;
  top: 0;
  right: 0;
  font-size: .42667rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #373c4a
}

.memberreport .contentdiv {
  float: left;
  width: 100%;
  height: calc(100% - 1.17333rem);
  overflow-x: hidden;
  overflow-y: scroll
}

.memberreport .contentdiv .contentdivinner {
  float: left;
  width: 100%;
  padding-bottom: .26667rem
}

.memberreport .contentdiv .contentdivinner .contenbox {
  float: left;
  width: 9.2rem;
  height: 2.93333rem;
  background: #fff;
  border-radius: .26667rem;
  margin-left: .4rem;
  margin-top: .4rem;
  padding: 0 .4rem
}

.memberreport .contentdiv .contentdivinner .contenbox .cttitle {
  float: left;
  width: 100%;
  border-bottom: .02667rem solid #c6c6ca;
  height: 1.06667rem
}

.memberreport .contentdiv .contentdivinner .contenbox .cttitle div {
  float: left;
  width: 40%;
  height: 100%;
  font-size: .37333rem;
  font-family: DIN;
  font-weight: 700;
  color: #373c4a
}

.memberreport .contentdiv .contentdivinner .contenbox .cttitle div:nth-child(2) {
  width: 60%;
  color: #6b728d;
  font-size: .32rem;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  font-weight: 500
}

.memberreport .contentdiv .contentdivinner .contenbox .btcontentbox {
  float: left;
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex
}

.memberreport .contentdiv .contentdivinner .contenbox .btcontentbox .div {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1
}

.memberreport .contentdiv .contentdivinner .contenbox .btcontentbox .div div {
  float: left;
  width: 100%;
  height: .32rem;
  font-size: .32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #373c4a;
  margin-top: .53333rem
}

.memberreport .contentdiv .contentdivinner .contenbox .btcontentbox .div div:nth-child(2) {
  margin-top: .26667rem
}

.memberreport .contentdiv .contentdivinner .contenbox .btcontentbox .div:nth-child(2) div {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center
}

.memberreport .contentdiv .contentdivinner .contenbox .btcontentbox .div:nth-child(3) div {
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end
}

.memberreport .contentdiv .contentdivinner .contenbox .btcontentbox .div:nth-child(3) div:nth-child(2) {
  color: #e81d32
}

[data-v-37fccb8e] {
  box-sizing: border-box;
  font-size: .37333rem
}

[data-v-37fccb8e] .van-field__right-icon .van-icon {
  font-size: .58667rem
}

.van-dialog__confirm[data-v-37fccb8e] {
  background: -webkit-linear-gradient(left, #ffdfb9, #f0a14f) !important;
  background: linear-gradient(90deg, #ffdfb9, #f0a14f) !important
}

.main_box[data-v-37fccb8e] {
  width: 100%
}

.main_box .head[data-v-37fccb8e] {
  position: relative;
  height: 1.17333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 .4rem;
  background: #fff
}

.main_box .head img[data-v-37fccb8e] {
  width: .29333rem;
  height: .53333rem
}

.main_box .head[data-v-37fccb8e] > :nth-child(2) {
  position: absolute;
  font-weight: 700;
  font-size: .48rem;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%)
}

.main_box .head[data-v-37fccb8e] > :last-child {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.main_box .head > :last-child > span[data-v-37fccb8e] {
  font-size: .37333rem
}

.main_box .head > :last-child > img[data-v-37fccb8e] {
  width: .45333rem;
  height: .45333rem;
  margin-left: .18667rem
}

.main_box .main_wrap[data-v-37fccb8e] {
  height: calc(100% - 1.17333rem);
  width: 100%;
  background: #eef0f8;
  color: #1d2548;
  overflow: auto
}

.main_box .main_wrap .pay_wrap[data-v-37fccb8e] {
  height: 1.33333rem;
  margin: .26667rem .4rem;
  padding: 0 .4rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-radius: .13333rem;
  background: #fff
}

.main_box .main_wrap .pay_wrap .pay_left[data-v-37fccb8e] {
  width: .8rem;
  height: .8rem;
  border-radius: 50%
}

.main_box .main_wrap .pay_wrap .pay_right[data-v-37fccb8e] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding-left: .4rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center
}

.main_box .main_wrap .pay_wrap .pay_right span[data-v-37fccb8e] {
  line-height: .61333rem;
  font-size: .42667rem
}

.main_box .main_wrap .pay_wrap .pay_right[data-v-37fccb8e] > :last-child {
  font-size: .37333rem;
  color: #6072a5
}

.main_box .main_wrap .pay_wrap .pay_right > :last-child > i[data-v-37fccb8e] {
  margin-left: .8rem
}

.main_box .main_wrap .pay_wrap[data-v-37fccb8e] > :last-child {
  width: .16rem;
  height: .26667rem
}

.main_box .main_wrap .pay_wrap_input[data-v-37fccb8e] {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin: .26667rem .4rem;
  height: 1.33333rem;
  border-radius: .13333rem;
  background-color: #fff
}

.main_box .main_wrap .pay_wrap_input .banks_input[data-v-37fccb8e] input.van-field__control::-webkit-input-placeholder {
  color: #1d2548
}

.main_box .main_wrap .pay_wrap_input .send_button[data-v-37fccb8e] {
  position: absolute;
  top: 50%;
  right: 0;
  margin-right: .37333rem;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%)
}

.main_box .main_wrap .pay_wrap_input[data-v-37fccb8e] .van-cell:after {
  border-bottom: none
}

.main_box .main_wrap .USDT_pay_wrap_input[data-v-37fccb8e] {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: .26667rem;
  padding-top: .48rem;
  margin: .26667rem .4rem;
  height: 2.4rem;
  border-radius: .13333rem;
  background-color: #fff;
  font-size: .32rem
}

.main_box .main_wrap .USDT_pay_wrap_input .usdt_rule_box[data-v-37fccb8e], .main_box .main_wrap .USDT_pay_wrap_input[data-v-37fccb8e] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between
}

.main_box .main_wrap .USDT_pay_wrap_input .usdt_rule_box .usdt_rule_box_protocol[data-v-37fccb8e] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex
}

.main_box .main_wrap .USDT_pay_wrap_input .usdt_rule_box .usdt_rule_box_protocol .usdt_rule_box_protocol_text[data-v-37fccb8e] {
  color: #2385ff;
  margin: 0 .13333rem
}

.main_box .main_wrap .USDT_pay_wrap_input .usdt_rule_item[data-v-37fccb8e] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  font-size: .37333rem
}

.main_box .main_wrap .USDT_pay_wrap_input .usdt_rule_item .bi[data-v-37fccb8e] {
  width: 2.66667rem;
  height: .96rem;
  background: #eef0f8;
  border-radius: .13333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center
}

.main_box .main_wrap .USDT_pay_wrap_input .usdt_rule_item .active[data-v-37fccb8e] {
  background: #237bff;
  border: .02667rem solid #237bff;
  color: #fff
}

.main_box .main_wrap .detail_wrap[data-v-37fccb8e] {
  background: #fff
}

.main_box .main_wrap .detail_wrap .detail_first[data-v-37fccb8e] {
  padding: 0 .4rem;
  height: 1.06667rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.main_box .main_wrap .detail_wrap .detail_first img[data-v-37fccb8e] {
  margin-left: .26667rem;
  width: .45333rem;
  height: .45333rem
}

.main_box .main_wrap .detail_wrap .detail_first[data-v-37fccb8e] > :nth-child(2) {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: right;
  margin-right: .13333rem
}

.main_box .main_wrap .detail_wrap .detail_second[data-v-37fccb8e] {
  padding: 0 .26667rem .26667rem .26667rem
}

.main_box .main_wrap .detail_wrap .detail_second > div[data-v-37fccb8e] {
  padding: 0 .26667rem;
  width: 9.46667rem;
  height: 1.65333rem;
  background: #eef0f8;
  border-radius: .13333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between
}

.main_box .main_wrap .detail_wrap .detail_second > div .detail_left[data-v-37fccb8e] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center
}

.main_box .main_wrap .detail_wrap .detail_second > div .detail_left[data-v-37fccb8e] > :last-child {
  font-size: .42667rem;
  font-family: DIN;
  font-weight: 700;
  line-height: .66667rem
}

.main_box .main_wrap .detail_wrap .detail_second > div .second_btn[data-v-37fccb8e] {
  width: 2.4rem;
  height: 1.06667rem;
  text-align: center;
  line-height: 1.06667rem;
  background: #2385ff;
  border-radius: .13333rem;
  font-size: .37333rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #fff
}

.main_box .main_wrap .detail_wrap .detail_third[data-v-37fccb8e] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 0 .4rem
}

.main_box .main_wrap .detail_wrap .detail_third .third_item[data-v-37fccb8e] {
  position: relative;
  width: 2.26667rem;
  padding: .26667rem 0;
  font-size: .29333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border-bottom: .02667rem solid #e1e1e1
}

.main_box .main_wrap .detail_wrap .detail_third .third_item[data-v-37fccb8e]:after {
  position: absolute;
  content: "";
  top: 50%;
  right: 0;
  width: .02667rem;
  height: .8rem;
  background: #dce1ee;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%)
}

.main_box .main_wrap .detail_wrap .detail_third .third_item img[data-v-37fccb8e] {
  margin-left: .05333rem;
  width: .24rem;
  height: .24rem
}

.main_box .main_wrap .detail_wrap .detail_third .third_item[data-v-37fccb8e] > :nth-child(2) {
  margin-top: .13333rem
}

.main_box .main_wrap .detail_wrap .detail_third .third_item .third_Bounced[data-v-37fccb8e] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around
}

.main_box .main_wrap .detail_wrap .detail_third .third_item .desShow[data-v-37fccb8e] {
  min-width: 3.2rem;
  max-width: 3.73333rem;
  background-color: #000;
  position: absolute;
  margin-bottom: 2.4rem;
  border-radius: .16rem;
  padding-left: .16rem;
  padding-right: .16rem;
  padding-top: .08rem;
  padding-bottom: .08rem;
  line-height: .48rem;
  margin-left: 1.06667rem;
  z-index: 999;
  border: .02667rem solid #ccc;
  font-size: .26667rem;
  margin-right: .4rem;
  box-sizing: border-box;
  color: #fff
}

.main_box .main_wrap .detail_wrap .detail_third[data-v-37fccb8e] > :last-child:after, .main_box .main_wrap .detail_wrap .detail_third[data-v-37fccb8e] > :nth-child(4n):after {
  display: none
}

.main_box .main_wrap .second_box[data-v-37fccb8e] {
  width: 100%;
  background: #fff;
  margin-top: .18667rem;
  padding: 0 .4rem
}

.main_box .main_wrap .second_box .input_box[data-v-37fccb8e] {
  width: 100%;
  margin-top: .18667rem;
  padding-top: .26667rem;
  border-bottom: .02667rem solid #e1e1e1
}

.main_box .main_wrap .second_box .input_box[data-v-37fccb8e] > :first-child {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin-bottom: .26667rem
}

.main_box .main_wrap .second_box .input_box[data-v-37fccb8e] > :last-child {
  position: relative
}

.main_box .main_wrap .second_box .input_box > :last-child > input[data-v-37fccb8e] {
  position: relative;
  height: 1.06667rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #1d2548;
  padding-left: .4rem;
  border: none
}

.main_box .main_wrap .second_box .input_box > :last-child > span[data-v-37fccb8e] {
  position: absolute;
  right: 0;
  top: 50%;
  width: 1.92rem;
  height: .66667rem;
  line-height: .66667rem;
  text-align: center;
  background: #eef5ff;
  border: .02667rem solid linear-gradient(90deg, #ffdfb9, #f0a14f);
  border-radius: .13333rem;
  color: #6b728d;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%)
}

.main_box .main_wrap .second_box .input_box[data-v-37fccb8e] > :last-child:after {
  position: absolute;
  //content: "VND";
  content: "";
  top: 50%;
  left: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%)
}

.main_box .main_wrap .second_box .foucs[data-v-37fccb8e] {
  border-bottom: .02667rem solid #237bff
}

.main_box .main_wrap .second_box .quick_box[data-v-37fccb8e] {
  width: 100%;
  padding-top: .18667rem
}

.main_box .main_wrap .second_box .quick_box > span[data-v-37fccb8e] {
  font-size: .29333rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #6072a5
}

.main_box .main_wrap .second_box .quick_box > .quick_item[data-v-37fccb8e] {
  margin-top: .26667rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap
}

.main_box .main_wrap .second_box .quick_box > .quick_item > span[data-v-37fccb8e] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  width: 2.05333rem;
  height: 1.06667rem;
  background: #eef0f8;
  border-radius: .13333rem;
  margin: 0 .21333rem .21333rem 0;
  border: .02667rem solid #fff
}

.main_box .main_wrap .second_box .quick_box > .quick_item[data-v-37fccb8e] > :nth-child(4n) {
  margin-right: 0
}

.main_box .main_wrap .second_box .quick_box > .quick_item .active[data-v-37fccb8e] {
  border: .02667rem solid #237bff;
  background: #eef5ff;
  color: linear-gradient(90deg, #ffdfb9, #f0a14f)
}

.main_box .main_wrap .second_box .btn_wrap[data-v-37fccb8e] {
  height: 2.93333rem;
  padding: .26667rem 0;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around
}

.main_box .main_wrap .second_box .btn_wrap .btn[data-v-37fccb8e], .main_box .main_wrap .second_box .btn_wrap[data-v-37fccb8e] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.main_box .main_wrap .second_box .btn_wrap .btn[data-v-37fccb8e] {
  width: 5.33333rem;
  height: 1.33333rem;
  background: #2385ff;
  border-radius: .13333rem;
  border: none;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: .45333rem;
  color: #fff
}

.main_box .main_wrap .second_box .btn_wrap .disable[data-v-37fccb8e] {
  background-color: #ccc
}

.main_box .main_wrap .second_box .btn_wrap .bottom_text[data-v-37fccb8e] {
  font-size: .29333rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #6072a5
}

.main_box .main_wrap .description[data-v-37fccb8e] {
  padding: .4rem;
  font-size: .29333rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #1d2548
}

.main_box .main_wrap .description span[data-v-37fccb8e] {
  line-height: .48rem
}

.main_box .main_wrap .description .description_red[data-v-37fccb8e] {
  color: #ef1145
}

.main_box .prompt_box[data-v-37fccb8e] {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  background: rgba(0, 0, 0, .5);
  z-index: 22;
  -webkit-transition: all 1s ease-out;
  transition: all 1s ease-out
}

.main_box .prompt_box .prompt_content[data-v-37fccb8e], .main_box .prompt_box[data-v-37fccb8e] {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.main_box .prompt_box .prompt_content[data-v-37fccb8e] {
  position: relative;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-justify-content: space-around;
  -ms-flex-pack: distribute;
  justify-content: space-around;
  width: 7.06667rem;
  height: 10.96rem;
  padding: .53333rem 0;
  background: #fff;
  border-radius: .4rem;
  color: #1d2548
}

.main_box .prompt_box .prompt_content .prompt_title[data-v-37fccb8e] {
  font-size: .42667rem;
  font-weight: 700
}

.main_box .prompt_box .prompt_content .prompt_text[data-v-37fccb8e] {
  font-size: .37333rem
}

.main_box .prompt_box .prompt_content .propmt_agree img[data-v-37fccb8e] {
  width: .34667rem;
  height: .34667rem
}

.main_box .prompt_box .prompt_content .bottom[data-v-37fccb8e] {
  width: 3.73333rem;
  height: 1.2rem;
  text-align: center;
  line-height: 1.2rem;
  color: #fff;
  background: #2385ff;
  border-radius: .13333rem
}

.main_box .prompt_box .prompt_content[data-v-37fccb8e]:after {
  position: absolute;
  content: "";
  top: 0;
  left: 50%;
  width: 3.2rem;
  height: .13333rem;
  background: #237bff;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%)
}

.main_box .bottom_pop[data-v-37fccb8e] {
  color: #1d2548;
  background: rgba(0, 0, 0, .5);
  z-index: 22
}

.main_box .bankList_wrap[data-v-37fccb8e] {
  position: relative;
  min-height: 1.86667rem;
  background: #fff;
  border-radius: .53333rem .53333rem 0 0
}

.main_box .bankList_wrap .pay_item[data-v-37fccb8e] {
  width: 100%;
  height: 1.86667rem;
  background: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 .4rem;
  border-bottom: .02667rem solid #e1e1e1
}

.main_box .bankList_wrap .pay_item .pay_left[data-v-37fccb8e] {
  width: 1.06667rem;
  height: 1.06667rem;
  border-radius: 50%
}

.main_box .bankList_wrap .pay_item .pay_right[data-v-37fccb8e] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding-left: .4rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center
}

.main_box .bankList_wrap .pay_item .pay_right span[data-v-37fccb8e] {
  line-height: .61333rem
}

.main_box .bankList_wrap .pay_item .pay_right[data-v-37fccb8e] > :last-child {
  color: #6072a5
}

.main_box .bankList_wrap .pay_item[data-v-37fccb8e] > :last-child {
  border-bottom: none
}

.main_box .mask[data-v-37fccb8e]:after {
  content: "";
  width: 100%;
  height: 100%;
  background: hsla(0, 0%, 100%, .5);
  position: absolute;
  top: 0;
  left: 0
}

.main_box .pay_item[data-v-37fccb8e] {
  width: 100%;
  height: 1.86667rem;
  background: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 .4rem;
  border-bottom: .02667rem solid #e1e1e1
}

.main_box .pay_item .pay_left[data-v-37fccb8e] {
  width: 1.06667rem;
  height: 1.06667rem;
  border-radius: 50%
}

.main_box .pay_item .pay_right[data-v-37fccb8e] {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding-left: .4rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center
}

.main_box .pay_item .pay_right span[data-v-37fccb8e] {
  line-height: .61333rem
}

.main_box .pay_item .pay_right[data-v-37fccb8e] > :last-child {
  color: #6072a5
}

.main_box .pay_item[data-v-37fccb8e] > :last-child {
  border-bottom: none
}

.main_box .keyboard[data-v-37fccb8e] {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #1d2548;
  background: rgba(0, 0, 0, .5);
  z-index: 22;
  -webkit-transition: opacity 1.5s linear;
  transition: opacity 1.5s linear
}

.main_box .keyboard .password_box[data-v-37fccb8e] {
  top: 4.93333rem;
  width: 7.06667rem;
  height: 4.37333rem;
  background: #fff;
  border-radius: .4rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.main_box .keyboard .password_box[data-v-37fccb8e], .main_box .keyboard .password_box[data-v-37fccb8e]:before {
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%)
}

.main_box .keyboard .password_box[data-v-37fccb8e]:before {
  content: "";
  top: 0;
  width: 3.2rem;
  height: .13333rem;
  background: #237bff
}

.main_box .keyboard .password_box[data-v-37fccb8e] > :first-child {
  font-size: .42667rem;
  font-family: PingFang SC;
  font-weight: 500
}

.main_box .keyboard .password_box[data-v-37fccb8e] > :last-child {
  font-size: .37333rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #2385ff
}

.main_box .keyboard .password_box > div[data-v-37fccb8e] {
  margin: .4rem 0;
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 0 .64rem
}

.main_box .keyboard .password_box > div > span[data-v-37fccb8e] {
  width: .85333rem;
  height: .85333rem;
  background: #ebedf2;
  border-radius: .13333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.main_box .keyboard .password_box > div > span span[data-v-37fccb8e] {
  display: block;
  width: .21333rem;
  height: .21333rem;
  background: #373c4a;
  border-radius: 50%
}

.main_box .board_box[data-v-37fccb8e] {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 5.46667rem;
  padding: .24rem 0;
  background: #f7f7f7;
  -webkit-transition: bottom .2s linear;
  transition: bottom .2s linear;
  z-index: 33;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex
}

.main_box .board_box .board_left[data-v-37fccb8e] {
  width: 7.54667rem;
  padding: 0 .24rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap
}

.main_box .board_box .board_left > span[data-v-37fccb8e] {
  width: 2.18667rem;
  height: 1.06667rem;
  font-size: .48rem;
  font-family: DIN;
  font-weight: 700;
  color: #373c4a;
  background: #fff;
  border-radius: .13333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.main_box .board_box .board_left > span[data-v-37fccb8e]:active {
  background: #dfe3ed
}

.main_box .board_box .board_left[data-v-37fccb8e] > :nth-child(10) {
  width: 4.64rem
}

.main_box .board_box .board_right[data-v-37fccb8e] > :first-child {
  width: 2.18667rem;
  height: 1.06667rem;
  background: #fff;
  border-radius: .13333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.main_box .board_box .board_right > :first-child img[data-v-37fccb8e] {
  width: .53333rem;
  height: .37333rem
}

.main_box .board_box .board_right[data-v-37fccb8e] > :first-child:active {
  background: #dfe3ed
}

.main_box .board_box .board_right[data-v-37fccb8e] > :last-child {
  width: 2.18667rem;
  height: 3.68rem;
  margin-top: .24rem;
  background: #2385ff;
  border-radius: .13333rem;
  font-size: .42667rem;
  font-family: PingFang SC;
  font-weight: 700;
  color: #fff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center
}

.main_box .board_box .board_right[data-v-37fccb8e] > :last-child:active {
  opacity: .7
}

.main_box .fadeIn[data-v-37fccb8e] {
  display: block
}

.main_box .show[data-v-37fccb8e] {
  top: 0
}

.main_box .close[data-v-37fccb8e] {
  top: 100%
}

.main_box .down[data-v-37fccb8e] {
  bottom: -50%
}

.banklistPop[data-v-37fccb8e] {
  width: 100%;
  height: 100%
}

.banklistPop .Pophead[data-v-37fccb8e] {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 1.17333rem
}

.banklistPop .Pophead > img[data-v-37fccb8e] {
  width: .29333rem;
  height: .53333rem;
  margin-left: .4rem
}

.banklistPop .Pophead > span[data-v-37fccb8e] {
  position: absolute;
  left: 50%;
  top: 50%;
  font-size: .48rem;
  font-family: PingFang SC;
  font-weight: 700;
  color: #1d2548;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%)
}

.banklistPop .bankcontent[data-v-37fccb8e] {
  width: 100%;
  box-sizing: border-box
}

.banklistPop .bankcontent .inputArea[data-v-37fccb8e] {
  width: 100%;
  box-sizing: border-box;
  padding: 0 .4rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 1.06667rem
}

.banklistPop .bankcontent .inputArea .fangIcon[data-v-37fccb8e] {
  width: .32rem;
  height: .32rem;
  margin-left: .13333rem
}

.banklistPop .bankcontent .inputArea .van-field[data-v-37fccb8e] {
  margin-left: .26667rem;
  height: 1.06667rem;
  border: none;
  background: #f5f6fa;
  border-radius: .26667rem;
  padding-left: .26667rem
}

.banklistPop .bankcontent .inputArea[data-v-37fccb8e] .van-field__body {
  height: 1.06667rem;
  margin-top: -.26667rem
}

.banklistPop .bankcontent .inputArea[data-v-37fccb8e] .van-field__body .van-field__control {
  height: 1.06667rem
}

.banklistPop .bankcontent .inputArea .van-cell[data-v-37fccb8e]:after {
  border: none
}

.banklistPop .bankcontent .inputArea .close[data-v-37fccb8e] {
  width: .53333rem;
  height: .53333rem;
  margin-right: .50667rem;
  cursor: pointer
}

.banklistPop .bankcontent .inputArea .finish[data-v-37fccb8e] {
  font-family: PingFang-SC-Medium;
  font-size: .37333rem;
  margin-left: .26667rem;
  font-weight: 400;
  font-stretch: normal;
  line-height: .24rem;
  letter-spacing: 0;
  color: #4f8dfe;
  width: 1.2rem;
  cursor: pointer;
  height: 100%;
  line-height: 1.06667rem
}

.banklistPop .bankcontent .banKlistContent[data-v-37fccb8e] {
  height: calc(100% - 2.13333rem);
  overflow: auto
}

.banklistPop .bankcontent .banKlistContent .bank-item[data-v-37fccb8e] {
  height: 1.33333rem;
  border-bottom: .02667rem solid #e4e4e4;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding-left: .93333rem
}

.banklistPop .bankcontent .banKlistContent .bank-item .banKName[data-v-37fccb8e] {
  font-family: PingFang-SC-Medium;
  font-size: .37333rem;
  font-weight: 400;
  font-stretch: normal;
  letter-spacing: 0;
  color: #1d2548
}

.banklistPop .bankcontent .banKlistContent .bank-item .banKName .otherBlue[data-v-37fccb8e] {
  color: #4f8dfe
}

.tooptip_pop[data-v-37fccb8e] {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #fff;
  background: transparent;
  z-index: 22
}

.pay_item2[data-v-37fccb8e] {
  position: relative;
  width: 2.32rem;
  margin-bottom: .4rem;
  height: 1.06667rem;
  margin-right: 2.5%;
  border: .02667rem solid #e1e1e1;
  border-radius: .13333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  overflow: hidden
}

.pay_item2 image[data-v-37fccb8e] {
  width: .58667rem;
  height: .58667rem
}

.pay_item2 text[data-v-37fccb8e] {
  color: #1d2548;
  height: .53333rem;
  font-size: .42667rem;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden
}

.pay_item2 .selected[data-v-37fccb8e] {
  position: absolute;
  right: -.02667rem;
  bottom: -.02667rem;
  width: .4rem;
  height: .4rem
}

.pay_item2 .recommend[data-v-37fccb8e] {
  position: absolute;
  top: 0;
  right: 0;
  width: .82667rem !important;
  height: .82667rem !important
}

.pay_itemactive[data-v-37fccb8e] {
  border: .02667rem solid #2385ff
}

.pay_itemactive text[data-v-37fccb8e] {
  color: #ffdfb9
}

.popItem {
  font-size: .32rem;
  padding: 0 .13333rem;
  text-align: center
}

.popItem > div {
  line-height: .42667rem !important
}

.card_type {
  background-color: #fff;
  width: 100%;
  height: 2rem;
  border-bottom: .26667rem solid #f3f3f5;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding-left: .4rem;
  padding-right: .4rem;
  box-sizing: border-box
}

.card_type, .card_type .right_btns {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex
}

.card_type .right_btns {
  height: 1.06667rem
}

.card_type .right_btns .jisu, .card_type .right_btns .normal {
  width: 2.4rem;
  line-height: 1.06667rem;
  height: 1.06667rem;
  text-align: center;
  background: #fff;
  border: .02667rem solid #4f8dfe;
  border-radius: .13333rem;
  font-size: .37333rem;
  font-family: PingFang SC;
  color: #4f8dfe
}

.card_type .right_btns .jisu {
  position: relative;
  margin-left: .26667rem
}

.card_type .right_btns .jisu .tuijian {
  position: absolute;
  width: .66667rem;
  height: .4rem;
  right: -.13333rem;
  top: -.13333rem
}

.card_type .right_btns .typeActive {
  background: #4f8dfe !important;
  color: #fff !important
}

.jisubox {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding-left: .93333rem;
  font-size: .37333rem;
  font-family: PingFang SC;
  font-weight: 500;
  height: .56rem;
  line-height: .56rem;
  margin-bottom: .26667rem
}

.jisubox .n_text {
  color: #333
}

.jisubox .o_text {
  color: #f76933
}

.jisubox .b_text {
  color: #4f8dfe
}

.jisuYoushiPop {
  width: 7.2rem;
  min-height: 9.46667rem;
  background: #fff;
  border-radius: .26667rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  padding-top: .53333rem
}

.jisuYoushiPop .tittle {
  font-size: .42667rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #2f3242
}

.jisuYoushiPop .kuaizhao {
  width: 5.86667rem;
  height: 1.09333rem;
  margin-top: .4rem;
  margin-bottom: .4rem
}

.jisuYoushiPop .youshi {
  width: 100%;
  padding-left: .64rem;
  padding-right: .69333rem;
  box-sizing: border-box;
  font-size: .32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #2f3242;
  margin-top: .13333rem;
  line-height: .48rem;
  text-align: left
}

.jisuYoushiPop .youshi .o_text {
  color: #f76933
}

.jisuYoushiPop .i_know {
  width: 3.46667rem;
  height: 1.06667rem;
  line-height: 1.06667rem;
  text-align: center;
  background: #4f8dfe;
  border: .02667rem solid #4f8dfe;
  border-radius: .13333rem;
  margin-top: .58667rem;
  font-size: .37333rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #fff;
  margin-bottom: .69333rem
}

.jisuYoushiPop .notip {
  width: 100%;
  height: .26667rem;
  margin-top: -.26667rem;
  margin-bottom: .53333rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  font-size: .32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #2f3242
}

.jisuYoushiPop .notip .checkbox {
  width: .4rem;
  height: .4rem;
  background: #f3f3f5;
  border: .02667rem solid #dbdbe7;
  border-radius: .08rem;
  margin-right: .26667rem
}

.popularizeUrl[data-v-269c184d] {
  text-align: center;
  background-color: #fff;
  height: 100%;
  overflow: hidden
}

.popularizeUrl .backhead[data-v-269c184d] {
  width: 100%;
  height: 1.17333rem;
  border-bottom: .02667rem solid #f6f6f6;
  font-size: .45333rem;
  color: #424653;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  background: #fff
}

.popularizeUrl .backhead img[data-v-269c184d] {
  width: .64rem;
  height: .64rem;
  position: absolute;
  left: .26667rem;
  top: .26667rem
}

.popularizeUrl .main-content[data-v-269c184d] {
  width: 100%;
  height: 100%
}

.popularizeUrl .main-content .content[data-v-269c184d] {
  text-align: center;
  width: 100%;
  height: 100%;
  overflow: scroll
}

.popularizeUrl .main-content .content .bg[data-v-269c184d] {
  width: 1.6rem;
  height: 1.6rem;
  border-radius: .21333rem;
  margin: 0 auto;
  margin-top: 1.49333rem;
  overflow: hidden
}

.popularizeUrl .main-content .content .bg img[data-v-269c184d] {
  width: 100%;
  height: 100%;
  background-size: cover
}

.popularizeUrl .main-content .content .fangkuai[data-v-269c184d] {
  width: 3.46667rem;
  height: .26667rem;
  background-size: cover;
  margin-top: .58667rem
}

.popularizeUrl .main-content .content .tittle[data-v-269c184d] {
  font-family: PingFang-SC-Bold;
  font-size: .37333rem;
  font-weight: 400;
  font-stretch: normal;
  letter-spacing: 0;
  color: #424653;
  margin-top: -.37333rem
}

.popularizeUrl .main-content .content .text[data-v-269c184d] {
  font-family: PingFang-SC-Medium;
  font-size: .24rem;
  font-weight: 400;
  font-stretch: normal;
  letter-spacing: 0;
  color: #9ca3bf;
  margin-top: .26667rem
}

.popularizeUrl .main-content .content .agentRule[data-v-269c184d] {
  width: 100%;
  background-size: cover;
  margin-bottom: 1.2rem
}

.van-swipe__track {
  height: 100%;
  width: 100%;

}
</style>



// WEBPACK FOOTER //
// src/components/inviter.vue